import React, {
  useRef,
  memo,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from "react";
import Map, {
  Marker,
  Source,
  Layer,
  NavigationControl,
  FlyToInterpolator,
  Popup,
} from "react-map-gl";
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { useDispatch, useSelector } from "react-redux";
import WebMercatorViewport from "viewport-mercator-project";
import Geocoder from "react-map-gl-geocoder";
import "react-map-gl-geocoder/dist/mapbox-gl-geocoder.css";
import markerImg from "../../../Assets/Images/orange-home.png";
import pointMarker from "../../../Assets/Images/blue-pin.png";
import "mapbox-gl/dist/mapbox-gl.css";
import "./SearchExplorer.css";
import { useLocation, useNavigate } from "react-router-dom";
import MarketSummary from "../MarketSummary/MarketSummary";
import { Col, Button, Row } from "reactstrap";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MUIButton from '@mui/material/Button';
import MarketProfile from "../MarketProfile/MarketProfile";
import { Filter } from "../Filters/Filter";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import AddMarket from "../AddMarket/AddMarket";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Snackbar from "@mui/material/Snackbar";
import Clear from "@mui/icons-material/Clear";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import ConfirmationPopup from "../SavedSearch/ConfirmationPopup";
import { MyMarketLayout } from "../../Layouts/LoggedInLayout/MyMarketLayout";
import TuneIcon from "@mui/icons-material/Tune";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MarketProperty from "../../HelperComponent/MarketProperty.js";
import ConstantData from "../../../Utils/Constant.js";
import { arraysHaveSameElements, commonFormatNumber, deleteCache, getCache, getTrafficLineWidth } from "../../../helpers/dataHelper.js";
import { debounce } from "@mui/material";
import { Link, Popper, Typography } from "@mui/material";
import SubscriptionDialog from "../../Common/SubscriptionDialog.js";
import { renderAsserDataBasedOnTypeId } from "../../../helpers/componentHelper.js";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper.js";
import { Config } from "../../../Utils/Config.js"
import { withStyles } from "@mui/styles";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import BookDemoDialog from "../../Common/BookDemoDialog.js";
import { buildTrafficLayer } from "../../../helpers/TrafficGroupingHelper.js";


var extp = [];
var circles = {};
var supplyExtp = [];
var supplyCircles = {};
var demandExtp = [];
var demandCircles = {};
var marketId;
var isEdit = false;
var isFav=false;
const pinStyle = {
  cursor: "pointer",
  fill: "#d00",
  stroke: "none",
};

const keyBasedOnId = { sizefilter: 1, koafilters: 2, glampingfilters: 3 };
 const InfoTooltip = withStyles(() => ({
      tooltip: {
        color: "white",
        letterSpacing: "1px",
        backgroundColor: "#6c757d",
        opacity: 1,
        fontSize: "11px",
        fontWeight: 400,
      },
    }))(Tooltip);

// favSearch decalarations
var cur_addrlat, cur_addrlng, cur_addr;
let favToEdit = null;
const applyToArray = (func, array) => func.apply(Math, array);
const SearchExplorer = memo((props) => {

  const selectedFilters = useSelector((state) => state.selectedFilters, (prev, next) => JSON.stringify(prev) === JSON.stringify(next));
  const developmentFilters = useSelector((state) => state.developmentFilters, (prev, next) => JSON.stringify(prev) === JSON.stringify(next));
  const filterOptions = useSelector((state) => state.filterOptions, (prev, next) => JSON.stringify(prev) === JSON.stringify(next));
  const activeTileSet = useSelector((state) => state.activeTileSet);
  const filterbyOptions = useSelector((state) => state.filterbyOptions);
  const activeCheckList = useSelector((state) => state.activeCheckList);
  const InfoPopup = useSelector((state) => state.InfoPopup);
  const searchPinAppending = useSelector((state) => state.searchPinAppending);
  const dispatch = useDispatch();
  var el = document.getElementsByClassName("mapboxgl-ctrl-geocoder--button");
  const location = useLocation();
  const navigate = useNavigate();
  const isDemoMarket = props?.demoMarket;
  const [favId, setFavId] = useState(null);
  const [searchId, setSearchId] = useState(null);
  const [searchName, setSearchName] = useState(null);
  const childRef = useRef();
  const marketRef = useRef();
  const loadfacilityData = useRef([]);
  const loaddevelopmentData = useRef([]);
  const [summaryInfo, setSummaryInfo] = useState({});
  const [demo_summaryInfo, setDemo_SummaryInfo] = useState({});
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const [trafficCounts, setTrafficCounts] = useState([])
  const [trafficCountsIndex, setTrafficCountsIndex] = useState([]);
  const [renderFlag, setRenderFlag] = useState(false);
  const [state, setToggle] = useState({
    rvParks: true,
    popCenter: false,
  });
  const [isLoading, setLoading] = useState(false);
  const [supplyValues, setSupplyValues] = useState({
    latitude: null,
    longitude: null,
  });
  const [summary, setSummary] = useState({
    showSummary: false,
    address: null,
    city: null,
    state: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    radius: null,
  });
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [filteredParksData, setFilteredParksData] = useState([]);
  const [profile, setProfile] = useState({
    showProfile: false,
    address: null,
    city: null,
    state: null,
    zipCode: null,
    latitude: null,
    longitude: null,
  });
  const [isEnabled, setEnable] = useState(true);
  const [marketCenter, setMarketCenter] = useState({
    latitude: null,
    longitude: null,
  });
  const [viewport, setViewPort] = useState({
    width: "100%",
    height: "100vh",
    longitude: -109.4293977,
    latitude: 47.0721469,
    zoom: 2.7,
    cursor: "pointer",
  });

  const [openMarket, setMarketButton] = useState(true);
  const [geoCoderValues, setgeoCodingData] = useState({});
  const [marketInfo, setMarketInfo] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [showCircle, setShowCircle] = useState(false);
  const [showSupplyCircle, setSupplyCircle] = useState(false);
  const [showDemandCircle, setDemandCircle] = useState(false);
  const mapRef = useRef();
  const geocoderContainerRef = useRef();
  const geocoderPopupContainerRef = useRef();
  const geocoderDebounceTimerRef = useRef(null);
  const latestGeocoderQueryRef = useRef("");
  const geocoderAbortControllerRef = useRef(null);
  const [stateList, setStateList] = React.useState([]);
  const [popup, setPopup] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPins, setSelectedPins] = useState({
    latitude: null,
    longitude: null,
    name: null,
    address: null,
    address1: null,
    city: null,
    state: null,
    country: null,
    zip: null,
    profileId: null,
  });
  let favProfileId;
  const [popupInfo, setPopupInfo] = useState(false);
  const [isSummaryLoading, setSummaryLoader] = useState(true);
  const [ismarketWizard, setMarketWizard] = useState(false);
  const [btnClose, setBtnClose] = useState(true);
  const [resetValues, resetMarketView] = useState(0);
  const [resetSupply, resetSupplyValue] = useState(0);
  const [resetDemand, resetDemandValue] = useState(0);
  const [rvParksData, setRvParkData] = useState({});
  const [radius, setRadius] = useState(50);
  const [supplyRadius, setSupplyRadius] = useState(50);
  const [demandRadius, setDemandRadius] = useState(50);
  const [profileInfo, setProfileInfo] = useState({});
  const [profileDtls, setProfileDtls] = useState({});
  const [profileAddress, setProfileAddress] = useState("");
  const [profileAdd, setProfileAdd] = useState("");
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [activitesList, setActivitesList] = useState([]);
  const [searchCount, setSearchCount] = useState(false);
  const [appliedFilterObj, setAppliedFilterObj] = React.useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [isFavoriteAddr, setFavoriteAddr] = useState(null);
  const [selectedActivities, setSelectedActivities] = React.useState([]);
  const [loaderProfile, setLoaderProfile] = React.useState(true);
  const [selectedMarketAddress, setSelectedMarketAddress] = React.useState("");
  const [removeCircle, setRemoveCircle] = React.useState(false);
  let isFreeUser = useMemo(() => localStorage.getItem('user') !== null && JSON.parse(localStorage.getItem('user')).usertype === 'Free' ? true : false, []);
  const [disableAdd, setDisableAdd] = React.useState(false);
  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false)
  const [showBookDemo, setShowBookDemo] = useState(false);
  const [locationState, setLocationState] = useState(null);
  const [assertPopType, setAssertPopType] = useState(null);
  const [assertPinData, setAssertPinData] = useState(null);
  const [assertLatLong, setAssertLatLong] = useState({ lat: null, lng: null });
  const [spotsInMarket, setSpotsInMarket] = useState({ min: false, max: false })
  const [tilesetload, setTilesetload] = useState();
  const showStorePins = useSelector((state) => state.showStorePins);
  const initialFilterIds = useSelector((state) => state.initialFilterIds);
  const viewPort = useSelector((state) => state.viewPort);
  const isMarketCenterAvailable = useSelector((state) => state.isMarketCenterAvailable);
  const prevActiveTileSetRef = useRef();
  const prevCenterRef = useRef(null);
  const needsUpdateRef = useRef(null);
  const containerRef = useRef(null);
  const preventIdleRef = useRef(true);
  const [trafficColorExp, setTrafficColorExp] = useState([]);
  const [searchTypeNew, setSearchTypeNew] = useState(1); // 1=Address, 2=Lat/Lng
  const [SearchTypeLabel, setSearchTypeLabel] = useState();
  const [topLatitude, setTopLatitude] = useState("");
  const [topLongitude, setTopLongitude] = useState("");
  const [latErrorTop, setLatErrorTop] = useState("");
  const [lonErrorTop, setLonErrorTop] = useState("");
  const [hideSearchExplorerBox, setHideSearchExplorerBox] = useState(false);  
  
  const handleRadioChange = (e, type) => {
    const newType = parseInt(e.target.value);
    setSearchTypeNew(newType);
    
    // Clear state when switching modes
    if (newType === 1) {
      // Switching to Address mode - clear lat/lng fields
      setTopLatitude("");
      setTopLongitude("");
      setLatErrorTop("");
      setLonErrorTop("");
    } else if (newType === 2) {
      // Switching to Lat/Lng mode - clear any previous address search
      clearSearchResult();
    }
  };

  const returnSearchTypeHtml =() => {
    return (
      <>
      {SearchTypeLabel && SearchTypeLabel.map((searchtype) => {
        const showInfo = searchtype.label === "Latitude/Longitude";

        return (
          <div className="radio-btns" key={searchtype.value}>
            <FormControlLabel
              value={searchtype.value}
              control={<Radio />}
              label={
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <span>{searchtype.label}</span>
                  {showInfo && (
                    <InfoTooltip
                      interactive
                      arrow
                      placement="top"
                      onOpen={() => (preventIdleRef.current = false)}
                      title={
                        <div style={{ width: "260px", lineHeight: 1.5, paddingTop: '5px' }}>
                          <strong style={{fontSize: '12px'}}>Acceptable Coordinate Formats</strong>
                          <ul style={{ marginTop: 8, paddingLeft: 16, marginBottom: '10px' }}>
                            <li>
                              <b style={{fontWeight: '500'}}>Degrees° Minutes' Seconds"</b> — e.g.{" "}
                              40° 30' 30" N, 74° 0' 21" W
                            </li>
                            <li>
                              <b style={{fontWeight: '500'}}>Decimal Degrees (DD)</b> — e.g.{" "}
                              40.50833, -74.00583
                            </li>
                            <li>
                              <b style={{fontWeight: '500'}}>Degrees° Minutes.MMM'</b> — e.g.{" "}
                              40° 30.505' N, 74° 0.350' W
                            </li>
                          </ul>
                          <p style={{ marginTop: 8, marginBottom: '5px' }}>
                            You can paste coordinates in any of the above formats — they will be
                            automatically converted to standard decimal degrees.
                          </p>
                        </div>
                      }
                    >
                      <span className="summary-kd-info pl-1">
                        <FontAwesomeIcon icon={faInfoCircle} />
                      </span>
                    </InfoTooltip>
                  )}
                </div>
              }
            />
          </div>
        );
      })}

      </>
    )
  };

  const parseCoordinate = (coordStr) => {
    if (!coordStr && coordStr !== 0) return null;
    
    // If already a number, return it (with rounding)
    if (typeof coordStr === 'number') {
      return Math.round(coordStr * 1e6) / 1e6;
    }
  
    // Convert to string and process
    coordStr = String(coordStr).trim().toUpperCase();
    coordStr = coordStr.replace(/[−–—]/g, '-');
    const isSouth = coordStr.includes('S');
    const isWest = coordStr.includes('W');
  
    const cleaned = coordStr.replace(/[NSEW]/g, '').replace(/[°]/g, '').trim();
  
    const dmsPattern = /(\d+)[\s]+(\d+)[\'\s]+([\d.]+)\"?/;
    const ddmPattern = /(\d+)[\s]+([\d.]+)[\'\s]?/;
    const ddPattern = /^-?\d+(\.\d+)?$/;
  
    let value;
    if (dmsPattern.test(cleaned)) {
      const [, deg, min, sec] = cleaned.match(dmsPattern);
      value = parseFloat(deg) + parseFloat(min) / 60 + parseFloat(sec) / 3600;
    } else if (ddmPattern.test(cleaned)) {
      const [, deg, min] = cleaned.match(ddmPattern);
      value = parseFloat(deg) + parseFloat(min) / 60;
    } else if (ddPattern.test(cleaned)) {
      return parseFloat(cleaned);
    } else {
      return null;
    }
  
    if (isSouth || isWest) value = -Math.abs(value);
    return Math.round(value * 1e6) / 1e6; // round to 6 decimals
  }

  const handlePasteLat = (e) => {
    const val = e.clipboardData.getData('text').trim();
    const parsed = parseCoordinate(val);
    if (parsed !== null) {
      e.preventDefault();
      setTopLatitude(val);
      setLatErrorTop('');
    }
  }

  const handlePasteLon = (e) => {
    const val = e.clipboardData.getData('text').trim();
    const parsed = parseCoordinate(val);
    if (parsed !== null) {
      e.preventDefault();
      setTopLongitude(val);
      setLonErrorTop('');
    }
  }

  const validateCoordinates = (latStr, lonStr) => {
    // If both empty
    if (!latStr && !lonStr) {
      return { valid: false, message: "Please enter both latitude and longitude." };
    }
  
    // Only latitude
    if (latStr && !lonStr) {
      return { valid: false, message: "Please enter longitude." };
    }
  
    // Only longitude
    if (!latStr && lonStr) {
      return { valid: false, message: "Please enter latitude." };
    }
  
    const latValue = parseCoordinate(latStr);
    const lonValue = parseCoordinate(lonStr);
  
    // Parsing failures
    if (latValue === null || isNaN(latValue)) {
      return { valid: false, message: "Invalid latitude format. Use Decimal Degrees or DMS/DDM format." };
    }
    if (lonValue === null || isNaN(lonValue)) {
      return { valid: false, message: "Invalid longitude format. Use Decimal Degrees or DMS/DDM format." };
    }
  
    // Range validation
    if (latValue < -90 || latValue > 90) {
      return { valid: false, message: "Latitude must be between -90 and 90." };
    }
    if (lonValue < -180 || lonValue > 180) {
      return { valid: false, message: "Longitude must be between -180 and 180." };
    }
  
    return { valid: true, lat: latValue, lon: lonValue };
  };

  const handleSearchTop = () => {
    if (searchTypeNew === 2) {
      // Trim inputs to check emptiness
      const latInput = (topLatitude || "").toString().trim();
      const lngInput = (topLongitude || "").toString().trim();
      const validation = validateCoordinates(latInput, lngInput);
      if (!validation.valid) {
        setSnackOpen({ ...snack, snackOpen: true, snackMsg: validation.message });
        setLatErrorTop("");
        setLonErrorTop("");
        return;
      }

      const { lat, lon } = validation;
      handleResult([lat, lon], "lat-lng");

      // Clear lat/lon fields and any errors after search
      setTopLatitude("");
      setTopLongitude("");
      setLatErrorTop("");
      setLonErrorTop("");
    } else {
      // Address search: focus geocoder input inside popup if present, otherwise fallback to document
      let input = null;
      try {
        if (geocoderPopupContainerRef && geocoderPopupContainerRef.current && (!isEdit &&!isFav)) {
          input = geocoderPopupContainerRef.current.querySelector('.mapboxgl-ctrl-geocoder--input');
        }
      } catch (e) {
        input = null;
      }
      if (!input) input = document.querySelector('.mapboxgl-ctrl-geocoder--input');
      if (input) input.focus();
    }
  };

  const setSelectedPin = (data, selection) => {
    let lat = parseFloat(data.latitude);
    let lng = parseFloat(data.longitude);
    setSelectedPins({
      ...selectedPins,
      latitude: lat,
      longitude: lng,
      name: data.name,
      address: data.Street_Address1 ? data.Street_Address1 : data.address,
      address1: data.Street_Address2 ? data.Street_Address2 : data.address1,
      city: data.city,
      state: data.state,
      country: data.country,
      profileId: data.profileId,
      zip: data.zip,
    });
  };
  const showPinsRef = useRef(showStorePins);
  useEffect(() => {
    dispatch({ type: "isMarketCenterAvailable", value: marketCenter.latitude && marketCenter.longitude ? true : false });
  }, [marketCenter])


  const isfavoriteCurrentAddress = (latitude, longitude, address) => {
    apiCommonTrigger("post", `${Config.API_URL}/maps/address/isfavorite`, {
      latitude,
      longitude,
      address,
    })
      .then((res) => {
        if (res.status === 200) {
          setFavoriteAddr(res.data.id);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };

  const favoriteCurrentAddress = () => {
    const latitude =
      cur_addrlat && cur_addrlat !== undefined ? cur_addrlat : null;
    const longitude =
      cur_addrlng && cur_addrlng !== undefined ? cur_addrlng : null;
    const address = cur_addr && cur_addr !== undefined ? cur_addr : null;
    const profileId =
      selectedPins.profileId !== null ? selectedPins.profileId : null;
    apiCommonTrigger("post", `${Config.API_URL}/maps/address/favorite`, {
      latitude,
      longitude,
      address,
      profileId,
    })
      .then((res) => {
        if (res.status === 200) {
          setFavoriteAddr(res.data.id);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };

  const triggerInitialMethod = async () => {
    await setAppliedFilter(null);
    setSpotsInMarket({ min: false, max: false })
    // Access the button element using its ID
    const button = document.getElementById("map-reset-search-explorer");

    // Trigger the click event programmatically
    if (button) {
      button.click();
      setLoading(true);

      return true;
    }
  };

  const getFilterValue = (app_filter, filterName) => {
    if (app_filter && app_filter.length > 0) {
      const foundFilter = app_filter.find(
        (x) => x.name.toLowerCase() === filterName.toLowerCase()
      );
      return foundFilter ? foundFilter.value : null;
    }
    return null;
  };

  const getManagementData = (app_filter, filterName) => {
    let resultData = getFilterValue(app_filter, filterName);
    return (resultData === "Yes" || resultData === true) ? true : null
  }

  const handleSetEmptyParksResponse = (response) => {
    childRef.current.setEmptyParksResponse(
      response.data.rvparks?.every((data) =>
        data?.data?.features?.length === 0 ? true : false
      )
    );
  };

  const isStoresInMarketSameAsInitial = () => {
    return (spotsInMarket.min === false && spotsInMarket.max === false) || (spotsInMarket.min === null && spotsInMarket.max === null) ? true : false
  }
  // delete @ appliedFilter
  const handleDelete = (chipToDelete, frm, _obj) => async () => {
    let totalFiltersLength = [
      ...(appliedFilter || []),
      ...(selectedActivities || []),
      ...(Object.values(spotsInMarket).filter(ele => ele !== null && ele !== false))
    ].length

    if (frm !== 'includeOperator' && totalFiltersLength === 1) {
      triggerInitialMethod();
      return true;
    }
    setLoading(true);

    let app_filter = appliedFilter.filter((chip) => chip.name !== chipToDelete);
    if (frm !== "activities" && frm !== "includeOperator" && frm !== 'spotsInMarket') {
      //  nullifying particular property
      if (
        appliedFilterObj[
        Object.keys(appliedFilterObj).find(
          (key) => key.toLowerCase() === chipToDelete.toLowerCase()
        )
        ] !== null
      ) {
        let key = Object.keys(appliedFilterObj).find(
          (key) => key.toLowerCase() === chipToDelete.toLowerCase()
        );
        key = null;
      }
      app_filter.reduce((acc, cur) => ({ ...acc, [cur.name]: cur.ovalue }), {});
    }
    if (
      frm === "activities" &&
      selectedActivities &&
      selectedActivities.length > 0 &&
      frm !== "includeOperator"
    ) {
      let list = selectedActivities;
      const index = list.findIndex((prod) => prod == chipToDelete); //use id instead of index
      if (index > -1) {
        //make sure you found it
        list.splice(index, 1);
      }
      setSelectedActivities(list);
      setLoading(true);

    } else if (frm === "spotsInMarket") {
      setSpotsInMarket((pre) => ({ ...pre, [chipToDelete]: false }))
    } else if (frm !== "includeOperator") {
      setLoading(false);
    }

    if (
      app_filter.length > 0 ||
      (selectedActivities && selectedActivities.length > 0) ||
      !isStoresInMarketSameAsInitial() ||
      frm === "includeOperator"
    ) {
      {
        (frm === "activities" && app_filter.length === 0) ||
          frm === "includeOperator"
          ? setAppliedFilter(appliedFilter)
          : "";
      }
      {
        (frm === "activities" && app_filter.length === 0) ||
          frm === "includeOperator"
          ? (app_filter = appliedFilter)
          : "";
      }
      setLoading(true);

      const radiuss = radius ? radius : null;
      const keyword = null;
      const lat =
        showCircle && circles !== null && selectedPins.latitude
          ? selectedPins.latitude
          : null;
      const long =
        showCircle && circles !== null && selectedPins.longitude
          ? selectedPins.longitude
          : null;

      const InternetConnectivityPayment =
        app_filter &&
          app_filter.length > 0 &&
          app_filter.find(
            (x) =>
              x.name.toLowerCase() === "internetConnectivityPayment".toLowerCase()
          )
          ? app_filter.find(
            (x) =>
              x.name.toLowerCase() ===
              "internetConnectivityPayment".toLowerCase()
          ).ovalue ||
          app_filter.find(
            (x) =>
              x.name.toLowerCase() ===
              "internetConnectivityPayment".toLowerCase()
          ).value
          : null;

      const Hookups = getFilterValue(app_filter, "hookups");
      const street = getFilterValue(app_filter, "street");
      const city = getFilterValue(app_filter, "city");
      const stateId = getFilterValue(app_filter, "stateId");
      const ShowersAndBathrooms = getFilterValue(app_filter, "showersAndBathrooms");
      const DumpStation = getFilterValue(app_filter, "dumpStation");
      const EATwentyAmp = getFilterValue(app_filter, "eaTwentyAmp");
      const EBThirtyAmp = getFilterValue(app_filter, "ebThirtyAmp");
      const ECFiftyAmp = getFilterValue(app_filter, "ecFiftyAmp");
      const OnSitePropane = getFilterValue(app_filter, "onSitePropane");
      const TentCamping = getFilterValue(app_filter, "tentCamping");
      const SiteLockers = getFilterValue(app_filter, "siteLockers");
      const InternetConnectivity = getFilterValue(app_filter, "internetConnectivity");
      const Cellphoneconnectivity = getFilterValue(app_filter, "cellphoneconnectivity");
      const Cafe = getFilterValue(app_filter, "cafe");
      const Cabins = getFilterValue(app_filter, "cabins");
      const GameRoomArcade = getFilterValue(app_filter, "gameRoomArcade");
      const RecHall = getFilterValue(app_filter, "recHall");
      const SportsCourts = getFilterValue(app_filter, "sportsCourts");
      const Petallowed = getFilterValue(app_filter, "petallowed");
      const Fishing = getFilterValue(app_filter, "fishing");
      const GolfCartRentals = getFilterValue(app_filter, "golfCartRentals");
      const Swimmingpool = getFilterValue(app_filter, "swimmingpool");
      const Lakeside = getFilterValue(app_filter, "lakeside");
      const BeachAccess = getFilterValue(app_filter, "beachAccess");
      const AttractionsDescriptions = getFilterValue(app_filter, "attractionsDescriptions");
      const hasOwner = getManagementData(app_filter, "hasOwner");
      const hasManagement = getManagementData(app_filter, "hasManagement");
      const AdditionalLodging = getFilterValue(app_filter, "AdditionalLodging");
      const FireRing = getFilterValue(app_filter, "FireRing");
      const PicnicTable = getFilterValue(app_filter, "PicnicTable");
      const SewerHookup = getFilterValue(app_filter, "SewerHookup");
      const VehicularAccess = getFilterValue(app_filter, "VehicularAccess");
      const WaterHookup = getFilterValue(app_filter, "WaterHookup");
      const BackIn = getFilterValue(app_filter, "BackIn");
      const PullInPullThrough = getFilterValue(app_filter, "PullInPullThrough");
      const LaundryAccess = getFilterValue(app_filter, "LaundryAccess");
      const SelfServiceCarWash = getFilterValue(app_filter, "SelfServiceCarWash");
      const DogParks = getFilterValue(app_filter, "DogParks");
      const Glamping = getFilterValue(app_filter, "glamping");
      const EVCharging = getFilterValue(app_filter, "electriclevehiclecharging");

      const Activities =
        selectedActivities.length > 0 ? selectedActivities.toString() : null;

      const IncludeAny = parseInt(includeAny) === 1 ? true : false;

      let isShowCircle =
        selectedPins.latitude === null && selectedPins.longitude === null
          ? false
          : true;
      circles = {};
      setSummary({ ...summary, showSummary: false });
      setProfile({ ...profile, showProfile: false });
      setShowCircle(false);

      const radioId = filterOptions.filterOptionsData.showby;
      const ops = filterOptions.filterOptionsData.filterBy
        .filter((item) => item.typeid === 1 && item.isactive)
        .map((item) => item.id);
      const koa = filterOptions.filterOptionsData.filterBy
        .filter((item) => item.typeid === 2 && item.isactive)
        .map((item) => item.id);
      const glamping = filterOptions.filterOptionsData.filterBy
        .filter((item) => item.typeid === 3 && item.isactive)
        .map((item) => item.id);
      let spotsList = { ...spotsInMarket }
      if (frm = 'spotsInMarket') {
        spotsList[chipToDelete] = false
      }
      const requestObject = {
        additionallodging: AdditionalLodging,
        attractionsdescriptions: AttractionsDescriptions,
        backin: BackIn,
        beachaccess: BeachAccess,
        cafe: Cafe,
        cabins: Cabins,
        cellphoneconnectivity: Cellphoneconnectivity,
        dogparks: DogParks,
        dumpstation: DumpStation,
        eatwentyamp: EATwentyAmp,
        ebthirtyamp: EBThirtyAmp,
        ecfiftyamp: ECFiftyAmp,
        firering: FireRing,
        fishing: Fishing,
        gameroomarcade: GameRoomArcade,
        golfcartrentals: GolfCartRentals,
        hookups: Hookups,
        internetconnectivity: InternetConnectivity,
        internetconnectivitypayment: InternetConnectivityPayment,
        lakeside: Lakeside,
        laundryaccess: LaundryAccess,
        onsitepropane: OnSitePropane,
        petallowed: Petallowed,
        picnictable: PicnicTable,
        pullinpullthrough: PullInPullThrough,
        rechall: RecHall,
        selfservicecarwash: SelfServiceCarWash,
        sewerhookup: SewerHookup,
        showersandbathrooms: ShowersAndBathrooms,
        sitelockers: SiteLockers,
        sportscourts: SportsCourts,
        swimmingpool: Swimmingpool,
        tentcamping: TentCamping,
        vehicularaccess: VehicularAccess,
        waterhookup: WaterHookup,
        searchid: 0,
        searchname: null,
        keyword: keyword,
        street: street,
        city: city,
        stateid: stateId,
        lat: lat,
        longi: long,
        radius: radiuss,
        hasowner: hasOwner,
        hasmanagement: hasManagement,
        glamping: Glamping,
        electriclevehiclecharging: EVCharging,
        activities: Activities,
        includeany: IncludeAny,
        koafilters: koa.join(","),
        sizefilters: ops.join(","),
        radioid: parseInt(radioId),
        glampingfilters: glamping.join(","),
        minspots: (!spotsList.min && spotsList.max) ? 1 : (spotsList.min || 1),
        maxspots: spotsList.max === false ? null : spotsList.max
      };
      apiCommonTrigger("post", `${Config.API_URL}/search`,
        requestObject)
        .then((res) => {
          if (res.status === 200) {
            handleSetEmptyParksResponse(res);
            const storeList = { min: spotsList.min || false, max: spotsList.max || false };
            receiveProps(
              { data: res.data, criteria: app_filter, spotsInMarket: storeList },
              true
            );
            childRef.current.resetFil(res.data.criteria);
            childRef.current.preFillArr(app_filter);
            childRef.current.setActivityUp(selectedActivities);
            childRef.current.setOperator(parseInt(includeAny));
            childRef.current.setSpotsListInMarket(storeList);
            setLoading(false);
            handleCloseFilter();
          } else {
            handlingCatchError(res, navigate);
          }
        })
        .catch((err) => {
          handlingCatchError(err, navigate);
        });
    } else if (
      app_filter.length === 0 &&
      selectedActivities &&
      selectedActivities.length === 0
    ) {
      setLoading(false);
      setAppliedFilter([]);
      setSearchCount(false);
      setAppliedFilterObj({});
      setActivitesList([]);
      setSelectedActivities([]);
      resetMapChanges(true);
      handleCloseFilter();
      setSpotsInMarket({ min: false, max: false })
    }
  };
  var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;
  const user = JSON.parse(userDetails || "{}");
  const isFreeUsers = (user.usertype || "") === "Free";

  const removeCircleLayers = () => {
    try {
      if (mapRef.current) {
        const map = mapRef.current.getMap(); // Get the map instance from the ref
        const layers = map.getStyle().layers; // Get all layers in the current style

        // Filter layers that match the desired condition
        layers.forEach((layer) => {
          if (layer.id.startsWith("layer-") && layer.type === "circle") {
            if (map.getLayer(layer.id)) {
              map.removeLayer(layer.id); // Remove the layer
              // Also, remove the source associated with the layer
              const sourceId = `source-${layer.id.split("-")[1]}`; // Assuming the source id follows a similar pattern
              if (map.getSource(sourceId)) {
                map.removeSource(sourceId); // Remove the source as well
              }
            }
          }
        });
      }
    } catch (error) {
      return false;
    }
  };

  // receive data from child component
  const receiveProps = (param, bool = false) => {
    setEnable(false);
    if (param.data && param.data.criteria !== null) {
      setSelectedSearch(param.data.criteria);
    }
    //  remove marker & profile if exists, when user made new search
    if (!showCircle && Object.keys(circles).length === 0) {
      setSelectedPins({
        ...selectedPins,
        latitude: null,
        longitude: null,
        name: null,
        address: null,
        address1: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        profileId: null,
      });
      setProfile({ ...profile, showProfile: false });
    }
    setSummaryInfo({ ...summaryInfo, summaryInfo: param.data.summary, rvcount: param.data.rvparkscount });
    setSummaryLoader(false);
    // to prevent user to save empty search
    if (param.data.rvParks === null) {
      setEnable(true);
      return true;
    }

    removeCircleLayers(); // remove all the exiting pins.
    const updatedJson = [];
    for (const jsonData of param.data.rvparks) {

      if (loadfacilityData.current.length) {
        const filteredItems = loadfacilityData.current.filter(
          (item) => item.typeid === jsonData.typeid
        );
        if (filteredItems.length) {
          filteredItems[0].features = jsonData.data.features;
          updatedJson.push(filteredItems[0]);
        } else {
          jsonData.data.typeid = jsonData.typeid;
          jsonData.data.isdisplay = true;
          updatedJson.push(jsonData.data);
        }
      } else {
        jsonData.data.typeid = jsonData.typeid;
        jsonData.data.isdisplay = true;
        updatedJson.push(jsonData.data);
      }
    }
    loadfacilityData.current = [];
    const showById = filterOptions?.filterOptionsData?.showby;
    const updatedParksDataValue = updatedJson.map((item) => {
      return {
        ...item,
        isdisplay: showById && activeCheckList[parseInt(showById)]
          ? activeCheckList[parseInt(showById)].includes(item.typeid)
          : true,
      };
    });
    loadfacilityData.current = updatedParksDataValue;
    setRenderFlag((prev) => !prev);
    setSearchCount(true);

    //  sorting the appliedFilter in ASC
    let sortedAppliedFilter = param.criteria.length > 0 ? param.criteria.sort((a, b) => {
      let temp1 = a.name.toLowerCase(),
        temp2 = b.name.toLowerCase();

      if (temp1 < temp2) {
        return -1;
      }
      if (temp1 > temp2) {
        return 1;
      }
      return 0;
    }) : [];

    // sortedAppliedFilter returns bool
    setAppliedFilter(sortedAppliedFilter);
    setAppliedFilterObj(param.data.criteria);
    let list = activitesList;
    setActivitesList(list && list.length > 0 ? list : param.Activites);
    let inc = param.includeValue ? param.includeValue : includeAny;
    setIncludeAny(inc);
    const str = param.data.criteria?.activities ?? "";

    const lis = str !== null && str !== undefined && str !== '' ? str.split(',') : [];
    setSelectedActivities(lis && lis.length > 0 ? lis : []);
    const storeList = param?.spotsInMarket;
    if (storeList) {
      setSpotsInMarket(storeList);
    }
    if (bool && developmentFilters) getDevelopmentData(param.data.criteria);


  };

  //calculate bounding box value for circle default adjustment
  const getBoundingValues = (points) => {
    if (points) {
      const pointsLong = points.geometry.coordinates.map((point) => point[0]);
      const pointsLat = points.geometry.coordinates.map((point) => point[1]);

      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)],
      ];

      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(cornersLongLat, {
        padding: { top: 100, bottom: 100, left: 100, right: 100 },
      });
      const { longitude, latitude, zoom } = viewport;
      setViewPort({
        ...viewport,
        latitude: latitude,
        longitude: longitude,
        zoom: zoom,
      });
    }

  };

  //draw circle
  const getCircle = (lats, lngs, radi, sel) => {
    circles = {};
    let radiusCal = sel === "2" ? radi : radius;
    let lat = sel === "2" ? selectedPins.latitude : lats;
    let lng = sel === "2" ? selectedPins.longitude : lngs;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    extp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      extp.push([ey, ex]);
    }
    circles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: extp,
      },
    };
    getBoundingValues(circles);
  };

  //draw circle
  const getSupplyCircle = (sLat, sLng) => {
    if (!supplyRadius) return null;
    supplyCircles = {};
    let radiusCal = supplyRadius;
    let lat =
      activeStep === 2 && sLat
        ? sLat
        : supplyValues.latitude
          ? supplyValues.latitude
          : selectedPins.latitude
            ? selectedPins.latitude
            : sLat;
    let lng =
      activeStep === 2 && sLng
        ? sLng
        : supplyValues.longitude
          ? supplyValues.longitude
          : selectedPins.longitude
            ? selectedPins.longitude
            : sLng;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    if (lat && lng) {
      // find the raidus in lat/lon
      var rlat = (radiusCal / earthsradius) * r2d;
      var rlng = rlat / Math.cos(lat * d2r);

      supplyExtp = [];
      if (dir === 1) {
        var start = 0;
        var end = points + 1;
      } else {
        var start = points + 1;
        var end = 0;
      }
      for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
        var theta = Math.PI * (i / (points / 2));
        let ey = lng + rlng * Math.cos(theta);
        let ex = lat + rlat * Math.sin(theta);
        supplyExtp.push([ey, ex]);
      }
      supplyCircles = {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: supplyExtp,
        },
      };
      getBoundingValues(supplyCircles);
    }
  };

  //draw circle
  const getDemandCircle = (sLat, sLng) => {
    demandCircles = {};
    let radiusCal = demandRadius;
    let lat = selectedPins.latitude ? selectedPins.latitude : sLat;
    let lng = selectedPins.longitude ? selectedPins.longitude : sLng;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    if (lat && lng) {
      // find the raidus in lat/lon
      var rlat = (radiusCal / earthsradius) * r2d;
      var rlng = rlat / Math.cos(lat * d2r);

      demandExtp = [];
      if (dir === 1) {
        var start = 0;
        var end = points + 1;
      } else {
        var start = points + 1;
        var end = 0;
      }
      for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
        var theta = Math.PI * (i / (points / 2));
        let ey = lng + rlng * Math.cos(theta);
        let ex = lat + rlat * Math.sin(theta);
        demandExtp.push([ey, ex]);
      }
      demandCircles = {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: demandExtp,
        },
      };
      getBoundingValues(demandCircles);
    }
  };

  //change center point on lat lng  changed
  const handleViewportChange = useCallback((newViewport) =>
    setViewPort(newViewport)
  );

  //change radius based on slider value
  const handleOnChangeRadius = (e, selection) => {
    let centerRadius = parseInt(e.target.value);
    if (e.target.name === "supplyRadius") {
      setSupplyRadius(centerRadius);
      setRadius(centerRadius);
    } else if (e.target.name === "demandRadius") {
      setDemandRadius(centerRadius);
    } else {
      setRadius(centerRadius);
      setSupplyRadius(centerRadius);
      setDemandRadius(centerRadius);
    }
    setViewPort({ ...viewport, zoom: 7 });
    if (showCircle) {
      if (activeStep === 2) {
        getSupplyCircle("", "", centerRadius, "2");
        resetSupplyValue(Math.random());
      } else if (activeStep === 3) {
        getDemandCircle("", "", centerRadius, "2");
        resetDemandValue(Math.random());
      } else {
        getCircle("", "", centerRadius, "2");
      }

      childRef.current.callOnSubmit(centerRadius, "1");
    }
  };

  const handleGeocoderViewportChange = useCallback(
    (newViewport) => {
      const geocoderDefaultOverrides = { transitionDuration: 300 };

      return setViewPort({
        ...newViewport,
        ...geocoderDefaultOverrides,
      });
    },
    [setViewPort]
  );

 const debouncedExternalGeocoder = useCallback((geocoder) => {
  geocoder._geocode = (query) => {
    const searchQuery = query.trim();

    latestGeocoderQueryRef.current = searchQuery;

    if (geocoderDebounceTimerRef.current) {
      clearTimeout(geocoderDebounceTimerRef.current);
    }

    if (geocoderAbortControllerRef.current) {
      geocoderAbortControllerRef.current.abort();
    }

    if (searchQuery.length < geocoder.options.minLength) {
      return Promise.resolve();
    }

    geocoderDebounceTimerRef.current = setTimeout(async () => {
      if (latestGeocoderQueryRef.current !== searchQuery) {
        return;
      }

      const controller = new AbortController();
      geocoderAbortControllerRef.current = controller;

      try {
        const searchParams = new URLSearchParams({
          access_token: process.env.REACT_APP_MAPBOX_TOKEN,
          autocomplete: "true",
          limit: String(geocoder.options.limit || 7),
          country: geocoder.options.countries || "us",
          language: geocoder.options.language || "en",
        });

        if (geocoder.options.types) {
          searchParams.set("types", geocoder.options.types);
        }

        const response = await fetch(
          `${geocoder.options.origin || "https://api.mapbox.com"}/geocoding/v5/mapbox.places/${encodeURIComponent(searchQuery)}.json?${searchParams}`,
          {
            signal: controller.signal,
          }
        );

        if (!response.ok) {
          throw new Error(`Mapbox API error: ${response.status}`);
        }

        const result = await response.json();
        if (
          controller.signal.aborted ||
          geocoderAbortControllerRef.current !== controller ||
          latestGeocoderQueryRef.current !== searchQuery
        ) {
          return;
        }

        const features = (result.features || []).map((feature) => ({
          ...feature,
          _source: "mapbox",
        }));

       // Give the results back to Mapbox Geocoder
        geocoder._typeahead.update(features);

        geocoder._eventEmitter.emit("results", {
          ...result,
          features,
        });
      } catch (error) {
        if (error.name === "AbortError") {
          return;
        }

        if (latestGeocoderQueryRef.current !== searchQuery) {
          return;
        }

        geocoder._eventEmitter.emit("error", {
          error,
        });
      } finally {
        if (geocoderAbortControllerRef.current === controller) {
          geocoderAbortControllerRef.current = null;
        }
      }
    }, 1000);
    
    return Promise.resolve();
  };
}, []);
//cleanup
useEffect(() => {
  return () => {
    if (geocoderDebounceTimerRef.current) {
      clearTimeout(geocoderDebounceTimerRef.current);
    }
    if (geocoderAbortControllerRef.current) {
      geocoderAbortControllerRef.current.abort();
    }
  };
}, []);
  // If user is Free, call /search/filters on page load and load default pins
  useEffect(() => {
    if (isFreeUser) {
      // Initialize search type to Address (1) on page load or refresh
      setSearchTypeNew(1);
      setTopLatitude("");
      setTopLongitude("");
      setLatErrorTop("");
      setLonErrorTop("");
      
      apiCommonTrigger("get", Config.API_URL + "/search/filters")
      .then((res) => {
        if (res.status === 200) {
          setSearchTypeLabel(res.data.filtersearchtypes)
        }
      }).catch((err) => {
        handlingCatchError(err, navigate);
      });
    }
  }, [isFreeUser]);
  useEffect(() => {
    getCache("market-search").then((response) => {
      setLocationState(response);
      if (response) {
        favToEdit = response && response.prevPath === "/fav-location" ? response.favorite : null
        setFavId(response.prevPath === "/fav-location" ? response.id : null);
        setSearchId(response.prevPath === "/saved-search" ? response.id : null);
        setSearchName(response.prevPath === "/saved-search" ? response.searchName : null);
        isFav = true;
      }
      deleteCache("market-search");
      loadStateLookup();
    }, []);
    const handleCustomEvent = (e) => {
      if (e?.detail?.bool) {
        resetMapChanges(false);
      }
    };
    window.addEventListener("myCustomEvent", handleCustomEvent);
    return () => {
      window.removeEventListener("myCustomEvent", handleCustomEvent);
    };
  }, []);

  const handleTrafficCountsLayer = () => {
    const map = mapRef.current?.getMap();
    const layerId = 'tile-line-layer';
    const shapeID = activeTileSet?.shapeid;
    const zoom = viewport?.zoom;
    if (zoom < ConstantData.advancedMapOverlaysIds.trafficZoomLevel) return;
    const colorCodes = activeTileSet.colorCodes.map(c => c.fillcolor);
    const { binData, legends, legendIndexes, colorExpr } = buildTrafficLayer({
      map,
      layerId,
      shapeID,
      zoom,
      colorCodes,
    });

    setTrafficCounts(legends);
    setTrafficCountsIndex(legendIndexes);
    setTrafficColorExp(colorExpr)
  };


  // useEffect(() => {
  //   const map = mapRef.current?.getMap();
  //   if (!map || activeTileSet?.layertype !== "line" || viewport.zoom < 10) return;

  //   const layerId = "tile-line-layer";
  //   let hasUpdated = false;

  //   const checkAndUpdate = () => {
  //     if (hasUpdated) return;
  //     if (!map.getLayer(layerId) || viewport.zoom < 10) return;
  //     const features = map.queryRenderedFeatures({ layers: [layerId] });
  //     if (features.length > 0) {
  //       handleTrafficCountsLayer(); 
  //       hasUpdated = true;
  //     } else {
  //       setTrafficCounts([])
  //       setTrafficCountsIndex([])
  //       map.once("sourcedata", checkAndUpdate);
  //     }
  //   };

  //   checkAndUpdate();

  //   return () => {
  //     hasUpdated = true;
  //   };

  // }, [activeTileSet]);

  const clearTrafficData = () => {
    setTrafficCounts([]);
    setTrafficCountsIndex([]);
    needsUpdateRef.current = false;
  };

  useEffect(() => {
    const map = mapRef.current?.getMap();
    if (!map || activeTileSet?.layertype !== "line" || viewport.zoom < 10) return;
    const layerId = "tile-line-layer";
    const sourceId = `fema-tileset-${activeTileSet?.sourcelayer}`;

    const runUpdateSafely = (bool = false) => {
      if (bool) {
        preventIdleRef.current = false;
      } else {
        preventIdleRef.current = true;
      }
      const features = map.queryRenderedFeatures({ layers: [layerId] });
      if (features.length > 0) {
        // if (shouldUpdateBasedOnDistance(map, prevCenterRef)) {
        handleTrafficCountsLayer();
        prevCenterRef.current = map.getCenter();
        // }
      } else {
        clearTrafficData()
      }
      needsUpdateRef.current = false;
    };

    const requestUpdate = () => {
      needsUpdateRef.current = true;
      if (preventIdleRef.current) runUpdateSafely(true);
    };

    // viewport move/zoom
    const handleMoveEnd = () => {
      needsUpdateRef.current = true;
      // wait until tiles settle
      map.once("idle", () => {
        if (needsUpdateRef.current) {
          runUpdateSafely();
        }
      });
    };

    // tiles loaded
    const handleSourceData = (e) => {
      if (e.sourceId === sourceId && e.isSourceLoaded && needsUpdateRef.current) {
        if (needsUpdateRef.current) runUpdateSafely();
      }
    };

    map.on("moveend", handleMoveEnd);
    map.on("idle", requestUpdate)
    map.on("sourcedata", handleSourceData);

    return () => {
      map.off("moveend", handleMoveEnd);
      map.off("idle", requestUpdate);
      map.off("sourcedata", handleSourceData);
    };
  }, [activeTileSet, viewport])

  //while call edit market
  useEffect(() => {
    if (location && location.state && location.state.isFrom === "my-market") {
      setViewPort({
        ...viewport, longitude: location.state.marketInfo.longitude, latitude: location.state.marketInfo.latitude,
        zoom: 6,
      })
      setSupplyRadius(location.state.marketInfo.supplyradius);
      setRadius(location.state.marketInfo.supplyradius);
      setDemandRadius(location.state.marketInfo.demandradius);
      marketId = location.state.marketInfo.id;
      setHideSearchExplorerBox(true);
      isEdit = true;
      setMarketWizard(true);
      setSelectedPins({
        ...selectedPins,
        latitude: location.state.marketInfo.latitude,
        longitude: location.state.marketInfo.longitude,
        name: null,
        address: null,
        address1: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        profileId: location.state.marketInfo.profileid
      });
      setMarketInfo({ ...marketInfo, marketName: location.state.marketInfo.marketname });
      setShowCircle(isEdit);
      circles = {};
      setProfileAddress({ ...profileAddress, profileAddress: location.state.marketInfo.address });
      setProfileAdd({ ...profileAdd, profileAdd: location.state.marketInfo.address });
      setSupplyValues({ ...supplyValues, latitude: location.state.marketInfo.latitude, longitude: location.state.marketInfo.longitude });
    }
    else {
      isEdit = false;
    }
  }, [location && location.state && location.state.isFrom === "my-market"]);

  useEffect(() => {
    if (selectedPins.latitude !== null && selectedPins.longitude !== null) {
      if (mapRef.current) {
        const map = mapRef.current.getMap();
        if (map.getLayer("route")) {
          map.removeLayer("route");
          map.removeSource("route"); // Also remove the source
        }
        getCircle(selectedPins.latitude, selectedPins.longitude, radius, "2");
      }

    }

  }, [resetValues]);

  //draw Supply circle for asynchronous calls
  useEffect(() => {
    if (selectedPins.latitude !== null && selectedPins.longitude !== null) {
      supplyCircles = {};
      getSupplyCircle();
    }
  }, [resetSupply]);

  //draw Demand circle for asynchronous calls
  useEffect(() => {
    if (selectedPins.latitude !== null && selectedPins.longitude !== null) {
      demandCircles = {};
      getDemandCircle();
    }
  }, [resetDemand]);

  useEffect(() => {
    if (searchId !== null) {
      fetchFilters();
      return;
    }
  }, [searchId])

  useEffect(() => {
    if (favToEdit !== null && favToEdit.id !== null && searchId === null) {
      editCurrentProfileFavorite(favToEdit.id);
      isFav = true;
    }
  }, [searchId, favToEdit])
  //intial load
  useEffect(() => {
    getCache("market-search").then((response) => {
      if (!response) {

        if (filterOptions && filterOptions.filterOptionsData) {
          getParksData("default");
        }
      }
    })
  }, [filterOptions, selectedFilters]);


  useEffect(() => {
    dispatch({ type: "viewPort", value: viewport });
  }, [viewport]);

  useEffect(() => {

    if (developmentFilters) {
      getDevelopmentData();
    }

  }, [developmentFilters]);

  const fetchFilters = () => {
    apiCommonTrigger("get", Config.API_URL + "/search/filters")
      .then((res) => {
        if (res.status === 200) {
          setActivitesList(res.data.listitems);
          // setSearchTypeLabel(res.data.filtersearchtypes)
          editSavedSearch(
            res.data.radioitems,
            res.data.dropdownitems,
            res.data.listitems
          );
        } else if (res.status === 401) {
          navigate("/");
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };
  const editSavedSearch = (radioItems, dropDownItems, listItems) => {
    setLoading(true)
    dispatch({ type: 'searchPinAppending', value: true });
    let arr = [];
    // setLoading(true);
    apiCommonTrigger("post", `${Config.API_URL}/search`, {
      searchid: searchId,
    })
      .then((res) => {
        if (res.status === 200) {
          // navigate(location.pathname, {});
          // setLoading(false);
          let IncludeAny = res.data.criteria?.includeany ? 1 : 0;
          setIncludeAny(IncludeAny)
          childRef.current.setOperator(IncludeAny)
          handleSetEmptyParksResponse(res)
          setAppliedFilterObj(res.data.criteria);
          const str = res.data.criteria.activities ?? "";
          const lis =
            str !== null && str !== undefined && str !== ""
              ? str.split(",")
              : [];
          setSelectedActivities(lis && lis.length > 0 ? lis : []);
          const storeList = { min: spotsInMarket.min || false, max: spotsInMarket.max || false };
          setSpotsInMarket(storeList)
          childRef.current.setSpotsListInMarket(storeList);
          const arrayKey = [
            "koafilters",
            "sizefilters",
            "glampingfilters",
            "radioid",
          ];
          let criteria = res.data.criteria;
          let filterObjectData = {};
          arrayKey.forEach((key) => {
            if (res.data.criteria.hasOwnProperty(key)) {
              // Store the value in a separate variable
              filterObjectData[key] = res.data.criteria[key];
              // Delete the key from res.data.criteria
              delete res.data.criteria[key];
            }
          });

          dispatch({ type: "filterObjectData", value: filterObjectData });

          childRef.current.resetFil(res.data.criteria);
          childRef.current.setActivityUp(lis);
          for (const criteriaKeys in criteria) {
            if (criteriaKeys !== "id") {
              if (criteria[criteriaKeys] !== null) {
                if (
                  radioItems.find(
                    (item) =>
                      item.value.toLowerCase() === criteriaKeys.toLowerCase()
                  )
                ) {
                  // getting name in criteriaKeys
                  // will get value in criteria[criteriaKeys]
                  let label = radioItems.find(
                    (item) =>
                      item.value.toLowerCase() === criteriaKeys.toLowerCase()
                  ).label;
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (
                  dropDownItems.find(
                    (item) =>
                      item.value.toLowerCase() === criteriaKeys.toLowerCase()
                  )
                ) {
                  let label = dropDownItems.find(
                    (item) =>
                      item.value.toLowerCase() === criteriaKeys.toLowerCase()
                  ).label;
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                // keys thata doesnt fall in dropdown nor radio
                if (criteriaKeys === "attractionsdescriptions") {
                  let label = "Attractions Descriptions";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (criteriaKeys === "cellphoneconnectivity") {
                  let label = "Cellphone Connectivity";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (criteriaKeys === "street") {
                  let label = "Street";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (criteriaKeys === "city") {
                  let label = "City";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (criteriaKeys === "stateid") {
                  let label = "RV Park's State";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (criteriaKeys === "keyword") {
                  let label = "Keyword";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (criteriaKeys === "radius") {
                  let label = "Radius";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                if (criteriaKeys === "hasowner") {
                  let label = "Owner Ship Info";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }

                if (criteriaKeys === "hasmanagement") {
                  let label = "Management Info";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }

                if (criteriaKeys === "eatwentyamp") {
                  let label = "20 Amp";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }

                if (criteriaKeys === "ebthirtyamp") {
                  let label = "30 Amp";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }

                if (criteriaKeys === "ecfiftyamp") {
                  let label = "50 Amp";
                  arr.push({
                    label: label,
                    name: criteriaKeys,
                    value: criteria[criteriaKeys],
                  });
                }
                arr = arr.filter(
                  (value, index, self) =>
                    index === self.findIndex((t) => t.name === value.name)
                );
                childRef.current.preFillArr(arr);
              }
            }
          }



          const updatedSpots = { min: res.data.criteria.minspots || false, max: res.data.criteria.maxspots || false };
          setSpotsInMarket(updatedSpots);

          receiveProps({ data: res.data, criteria: arr, Activites: listItems, includeValue: IncludeAny, spotsInMarket: updatedSpots }, true);
          // childRef.current.openFilter(true);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      }).finally(() => {
        dispatch({ type: 'searchPinAppending', value: false });
        setLoading(false);
      })
  }
  const loadStateLookup = () => {
    apiCommonTrigger("get", Config.API_URL + "/lookup/states")
      .then((res) => {
        if (res.status === 200) {
          setStateList(res.data);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };
  //get result from geocoder
  const handleResult = async (data, type) => {
    preventIdleRef.current = true;
    let lat, lng;

  if (type === "demo-market" || type === "lat-lng") {
    // If data[0] and data[1] are already numbers, use them directly
    // Otherwise, parse them as strings (for demo-market which might pass strings)
    if (typeof data[0] === 'number' && typeof data[1] === 'number') {
      lat = data[0];
      lng = data[1];
    } else {
      lat = parseCoordinate(data[0]);
      lng = parseCoordinate(data[1]);
    }
  } else {
    lat = data?.result?.center?.[1];
    lng = data?.result?.center?.[0];
  }

  if (lat === undefined || lng === undefined || lat === null || lng === null || Number.isNaN(lat) || Number.isNaN(lng)) {
    return;
  }

    setProfileInfo({});
    setProfileDtls({});
    getProfileInfo(null, lat, lng, type);
    setViewPort({ ...viewport, latitude: lat, longitude: lng, zoom: 7 });
      setSummary({
        ...summary,
        showSummary: false,
        latitude: lat,
        longitude: lng,
      });
      setHideSearchExplorerBox(true);
  };

  //get rv parks data
  const getParksData = async (type = 'default') => {
    if (isDemoMarket) {
      return true;
    }
    if (type === "default" && locationState && locationState.prevPath && locationState.prevPath.includes('saved-search') && locationState.fromPage != "filter") {
      setLocationState(null)
      return true;
    }
    const showById = filterOptions.filterOptionsData.showby;
    const getMatchingIds = (filterKey) => {
      return filterOptions.filterOptionsData.filterBy
        .filter(
          (item) =>
            item.typeid === parseInt(keyBasedOnId[filterKey]) &&
            item.isactive === true
        )
        .map((item) => item.id);
    };

    if (!selectedFilters || !selectedFilters[parseInt(showById)]) {
      setLoading(false);
      return true;
    }

    if (filterOptions.bool) {
      const updatedParksData = loadfacilityData.current.map((item) => {
        return {
          ...item,
          isdisplay: activeCheckList[parseInt(showById)].includes(item.typeid),
        };
      });

      loadfacilityData.current = updatedParksData;
      setRenderFlag((prev) => !prev);
      setLoading(false);
      return true;
    }

    const isFilterData = appliedFilter && appliedFilter.length > 0;
    const isActivitiesEmpty =
      selectedActivities && selectedActivities.length > 0;

    if ((isFilterData || isActivitiesEmpty || !isStoresInMarketSameAsInitial()) && type === "default") {

      childRef.current.callOnSubmitdata("2");
      return true;
    }
    setLoading(true);

    const selectedLists = selectedFilters[parseInt(showById)];

    const newParksData = []; // To accumulate parks data
    loadfacilityData.current = [];

    dispatch({ type: "searchPinAppending", value: true });
    dispatch({ type: "showStorePins", value: true });
    try {
      for (let selectedList of selectedLists) {
        const sizeFilterIds = getMatchingIds("sizefilter");
        const koaFilterIds = getMatchingIds("koafilters");
        const glampingFilterIds = getMatchingIds("glampingfilters");

        const dataValue = Object.keys(selectedFilters)[0];
        const match = filterOptions.filterOptionsData.filterBy.find(
          (item) =>
            parseInt(item.id) === parseInt(selectedList) &&
            parseInt(item.typeid) === parseInt(dataValue)
        );

        const requestObject = {
          showby: selectedList,
          sizefilters: sizeFilterIds.join(","),
          koafilters: koaFilterIds.join(","),
          glampingfilters: glampingFilterIds.join(","),
          colorcode: match.colorcode,
        };

        const res = await apiCommonTrigger("post", `${Config.API_URL}/maps/pois/rvparks`,
          requestObject
        )

        if (res.status === 200) {
          childRef.current.setEmptyParksResponse(false)
          res.data.typeid = match.id;
          res.data.isdisplay = true;
          newParksData.push(res.data);
          if (showPinsRef.current) {
            loadfacilityData.current.push(res.data);
          }
          setRenderFlag((prev) => !prev);
          setLoading(false);
        } else {
          handlingCatchError(res, navigate);
        }
      }
    }
    catch (error) {
      handlingCatchError(error);
    }


    if (showPinsRef.current) {
      dispatch({ type: "mapParkData", value: newParksData });
    }
    dispatch({ type: "searchPinAppending", value: false });
    setLoading(false);

  };
  const getDevelopmentData = async (objData = null) => {


    setLoading(true);
    dispatch({ type: "searchPinAppending", value: true });
    dispatch({ type: "showStorePins", value: true });
    try {
      for (const obj of developmentFilters) {
        if (objData || !obj.isBool) {
          objData = objData || selectedSearch;
          let inputData = {
            assetid: obj.id,
            colorcode: obj.color,
            latitude: objData?.lat ?? null,
            longitude: objData?.longi ?? null,
            radius: objData?.radius ?? null,
            street: objData?.street ?? null,
            state: objData?.stateid ?? null,
            city: objData?.city ?? null,
          }
          const developmentres = await apiCommonTrigger("post", `${Config.API_URL}/maps/pois/assets`, inputData)
          if (developmentres.status === 200) {
            const data = {
              ...developmentres.data,
              isdisplay: !obj.isBool ? true : obj.data?.isdisplay ?? false
            };
            obj.data = data;
            obj.isBool = true;
            setLoading(false);
          }
          else {
            handlingCatchError(developmentres, navigate);
          }
        }
      }
      loaddevelopmentData.current = developmentFilters.map(item => item.data);
    }
    catch (error) {
      handlingCatchError(error);
    }


    dispatch({ type: "searchPinAppending", value: false });
    setLoading(false);
    setRenderFlag(prev => !prev);

  }
  //clear search box results
  const clearSearchResult = () => {
    if (el && el.length !== undefined && el.length > 0) {
      el[0].click();
    }
    // Clear popup search box if it exists
    if (geocoderPopupContainerRef && geocoderPopupContainerRef.current && (!isEdit && !isFav)) {
      const popupClearButton = geocoderPopupContainerRef.current.querySelector('.mapboxgl-ctrl-geocoder--button');
      if (popupClearButton) {
        popupClearButton.click();
      }
    }
  };
  //get info details for clicked points


  const getDevelopmentInfo = async (typeId, profileId, latitude, longitude) => {
    try {
      const developmentres = await apiCommonTrigger("post", `${Config.API_URL}/Maps/pois/assets/info`, {
        assetid: typeId,
        pinid: profileId,
      })
      const pinResult = developmentres.data[0];
      setAssertLatLong({ lat: latitude, lng: longitude });
      setAssertPinData(pinResult);
      setAssertPopType(typeId);
    }
    catch (error) {
      handlingCatchError(error);
    }

  };
  useEffect(() => {
    if (summaryInfo.summaryInfo) setDisableAdd(Object.values(summaryInfo.summaryInfo).some(Boolean))
  }, [summaryInfo])
  //get details of clicked points

  const getcoordinates = (event) => {
    preventIdleRef.current = true;
    clearSearchResult();
    let latitude = event.lngLat[1];
    let longitude = event.lngLat[0];

    // Check if free user clicked on a default pin (circle layer from default pins)
    if (isFreeUser && !isDemoMarket && event.features && event.features[0] && 
        event.features[0].layer && event.features[0].layer.type === "circle") {
         return true
    }

    if (ConstantData.devtypeid.typeid.includes(event.features?.[0]?.properties?.typeid)) {
      const featureId = event.features[0].properties.facilityid || event.features[0].properties.id || event.features[0].id;
      getDevelopmentInfo(event.features[0].properties.typeid, featureId, latitude, longitude)
      setProfile({ ...profile, showProfile: false });
      return true;
    }
    setAssertLatLong({ lat: null, lng: null });

    if (isFreeUser && !isDemoMarket) {
      const latStr = latitude.toFixed(6);
      const lngStr = longitude.toFixed(6);
      setTopLatitude(latStr);
      setTopLongitude(lngStr);
      setSearchTypeNew(2); // Switch to Lat/Lng mode
      setLatErrorTop("");
      setLonErrorTop("");
      
      // Also call reverse geocoding to get address info
      callGeocoding(latitude, longitude, "demo-market", "getcoordinates");
      setViewPort({ ...viewport, latitude: latitude, longitude: longitude, zoom: 7 })
    }
    else if (
      event.features[0] &&
      event.features[0].layer.type === "circle" &&
      activeStep === 0
    ) {
      setProfile({ ...profile, showProfile: true });
      let profileId =
        event.features[0].properties.profileid !== undefined
          ? event.features[0].properties.profileid
          : null;
      if (activeStep === 2) {
        setSupplyValues({ ...supplyValues, latitude, longitude });
        getSupplyCircle(latitude, longitude);
      } else {
        //resetOnMarketCenter("2");
        getProfileInfo(profileId, latitude, longitude);
      }
      //resetMarketView(Math.random());
    } else {
      if (activeStep === 2) {
        setSupplyValues({ ...supplyValues, latitude, longitude });
        getSupplyCircle(latitude, longitude);
      } else if (activeStep === 0) {
        //resetOnMarketCenter("2");
        setProfile({ ...profile, showProfile: false });
        // callGeocoding(latitude, longitude);
        let profileId =
          event.features?.[0]?.properties.profileid !== undefined
            ? event.features[0].properties.profileid
            : null;
        getProfileInfo(profileId, latitude, longitude);
      }
    }
  };

  //reverse geo coding for get market center;
  const callGeocoding = async (latitude, longitude, type, isFrom) => {
    try {
  
      const parsedLat = parseCoordinate(latitude);
      const parsedLng = parseCoordinate(longitude);
  
      const response = await fetch(
        "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
          parsedLng +
          "," +
          parsedLat +
          ".json?country=US&access_token=" +
          process.env.REACT_APP_MAPBOX_TOKEN,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      const data = await response.json();
      const feature = data.features?.[0];
  
      // ❌ NOT VALID — return false
      if (!feature) {
        setSnackOpen({ ...snack, snackOpen: true, snackMsg: "Only U.S. locations are supported. Please provide latitude and longitude within the United States." });
        setLatErrorTop("");
        setLonErrorTop("");
        return false;
      }

      // ✅ VALID US LOCATION — continue existing logic
      // (your remaining code stays unchanged)
      setgeoCodingData({
        ...geoCoderValues,
        geoCoderValues: feature,
      });
  
      setProfile({
        ...profile,
        showProfile: isFrom === "getcoordinates" && isDemoMarket ? true : false,
        address: feature.place_name,
      });
  
      setSelectedMarketAddress(feature.place_name);
      setProfileInfo({});
      setProfileDtls({});
      setProfileAddress(pre => ({
        ...pre,
        profileAddress: feature.place_name,
      }));
  
      if (!summary.showSummary) {
        setProfileAdd(pre => ({
          ...pre,
          profileAdd: feature.place_name,
        }));
      }
  
      const info = {
        latitude: parsedLat || 0,
        longitude: parsedLng || 0,
        name: null,
        address: null,
        address1: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        profileId: null,
      };
  
      cur_addrlat = parsedLat;
      cur_addrlng = parsedLng;
      cur_addr = feature.place_name;
  
      isfavoriteCurrentAddress(parsedLat, parsedLng, cur_addr);
      setSelectedPin(info, "db");
  
      if (isFreeUser) {
        callMarketCenter(parsedLat, parsedLng, true);
      } else {
        setPopupInfo(isFrom === "getcoordinates" && isDemoMarket ? false : true);
      }
  
      if (type === "demo-market") {
        handleDemoMarketCenter(parsedLat, parsedLng);
      }
  
      // ✅ SUCCESS → return true
      return true;
  
    } catch (error) {
      console.error("Error:", error);
      return false; // fallback
    }
  };
  
  const generateMapboxColorExpression = (property, colorData, colorType, defaultColor) => [
    'case',
    ...colorData.flatMap(c => [['==', ['get', property], c.name], c[colorType]]),
    defaultColor
  ];
  const createLayer = (id, type, source, sourceLayer, paint) => ({
    id,
    type,
    source,
    'source-layer': sourceLayer,
    paint
  });

  //close/open market summary
  const toggleBtnClose = useCallback(
    (con) => {
      setBtnClose(con);
      setMarketButton(con);
    },
    [btnClose]
  );

  const showAddMarket = useCallback(
    (show, isFrom, id) => {
      setMarketWizard(show);
      if (isFrom === "1") {
        resetMapChanges(true);
      } else {
        setProfile(pre => ({
          ...pre,
          showProfile: selectedPins.profileId ? true : false,
        }));
        setPopupInfo(selectedPins.profileId ? false : true);
        setSummary(pre => ({ ...pre, showSummary: true }));
        setSupplyCircle(false);
        setDemandCircle(false);
        setActiveStep(0);
      }
      localStorage.setItem("opened", false);
    },
    [ismarketWizard]
  );

  //get market info from add market
  const getMarketInfo = useCallback((value) => {
    setMarketInfo(pre => ({ ...pre, marketName: value }));
  }, []);

  //get active step from add market
  const setActiveSteps = useCallback((value) => {
    setActiveStep(value);
    if (value === 2) {
      getSupplyCircle();
      setSupplyCircle(true);
      resetSupplyValue(Math.random());
    } else if (value === 3) {
      getDemandCircle();
      setDemandCircle(true);
      resetDemandValue(Math.random());
    }
    if (value === 2 || value === 3) {
      setProfile(pre => ({ ...pre, showProfile: false }));
      setSummary(pre => ({ ...pre, showSummary: false }));
      setPopupInfo(false);
    }
  }, []);

  //show market summary popup
  const toggleSummary = useCallback(
    (show) => {
      if (show) {
        setSummary((prev) => {
          return {
            ...prev,
            showSummary: show,
          };
        });
      } else {
        setSummary(pre => ({
          ...pre,
          showSummary: false,
        }));
        setBtnClose(show);
      }
    },
    [summary.showSummary]
  );
  //show market profile popup
  const toggleProfile = useCallback(
    (show) => {
      if (show) {
        setProfile((prev) => {
          return {
            ...prev,
            showProfile: show,
          };
        });
      } else {
        setProfile(pre => ({
          ...pre,
          showProfile: false,
        }));

        setSelectedPins(pre => ({
          ...pre,
          latitude: null,
          longitude: null,
          name: null,
          address: null,
          address1: null,
          city: null,
          state: null,
          country: null,
          zip: null,
          profileId: null,
        }));

        setSummary(pre => ({
          ...pre,
          showSummary: false,
        }));
      }
    },
    [profile.showProfile]
  );

  //market center actions
  const callMarketCenter = useCallback((lat, lng, bool) => {
    setSummary(pre => ({
      ...pre,
      showSummary: bool,
      radius: radius,
    }));
    setSearchCount(false);
    setShowCircle(bool);
    resetMarketView(Math.random());
    setMarketCenter({ ...marketCenter, latitude: lat, longitude: lng });
  }, []);


  //for call market summary api
  useEffect(() => {
    if (showCircle && filterOptions && filterOptions.filterOptionsData && !isDemoMarket) {
      localStorage.setItem("demo-token", process.env.REACT_APP_DEMO_TOKEN);
      childRef.current.callOnSubmit(radius, "1", true);
    }
    if (selectedPins.profileId !== null) {
      setProfileDtls({ ...profileDtls, profileDtls: selectedPins });
      if (location?.state?.isFrom != "my-market") {
        setProfileAddress({});
        setProfileAdd({});
      }
    } else if (selectedPins.profileId == null) {
      setProfileAdd({ ...profileAdd, profileAdd: profileAddress && profileAddress.profileAddress ? profileAddress.profileAddress : '' });
    }
  }, [showCircle, marketCenter.latitude, marketCenter.longitude, filterOptions]);

  //Rest to map default
  const resetMapChanges = (isProgrammatic = true, type = "default", navigationPath = location.pathname, disableNavigate = false) => {
    if (!disableNavigate) {
      navigate(navigationPath, {});
    }
    dispatch({ type: 'RESET_APP_STATE' });
    navigate(location.pathname, {});
    setLocationState(null);
    favToEdit = null;
    setSearchId(null);
    setSearchName(null);
    setOpenPopup(false);
    setEnable(true);

    if (el && el.length !== undefined && el.length > 0) {
      el[0].click();
    }
    isEdit = false;
    isFav = false;
    childRef.current.resetFil(null);
    childRef.current.openFilter(false);
    childRef.current.setActivityUp([]);
    childRef.current.setSpotsListInMarket({ min: false, max: false });
    setSpotsInMarket({ min: false, max: false })
    setAppliedFilter([]);
    setSelectedActivities([]);
    setActivitesList([]);
    setIncludeAny(0);
    setSelectedSearch([]);
    setSearchCount(false);
    // filter wont be prefilled
    setAppliedFilterObj({});
    setViewPort({
      ...viewport,
      longitude: -109.4293977,
      latitude: 47.0721469,
      zoom: 2.7,
    });
    setPopupInfo(false);
    setRadius(50);
    setSupplyRadius(50);
    setDemandRadius(50);
    setSummary({ ...summary, showSummary: false });
    setProfile({ ...profile, showProfile: false });
    setShowCircle(false);
    setSupplyCircle(false);
    setDemandCircle(false);
    handleCloseFilter();
    circles = {};
    demandCircles = {};
    supplyCircles = {};
    // resetSupplyValue(Math.random());
    // resetDemandValue(Math.random());
    setActiveStep(0);
    // Reset search type to Address and clear lat/lon fields
    setSearchTypeNew(1);
    setTopLatitude("");
    setTopLongitude("");
    setLatErrorTop("");
    setLonErrorTop("");
    setSelectedPins({
      ...selectedPins,
      latitude: null,
      longitude: null,
      name: null,
      address: null,
      address1: null,
      city: null,
      state: null,
      country: null,
      zip: null,
      profileId: null,
    });
    setRvParkData({});
    setMarketWizard(false);
    setMarketInfo({});
    setMarketCenter({ ...marketCenter, latitude: null, longitude: null });
    if (isProgrammatic) {
      getParksData('reset');
    }
    dispatch({ type: 'developmentFilters', value: [] });
    loaddevelopmentData.current = [];
    const filterResetBtn = document.getElementById("reset-btn-filter");
    if (filterResetBtn) filterResetBtn.click();
    setHideSearchExplorerBox(false);
  };
  //get store profile details
  const getProfileInfo = (id, latitude, longitude, type, isFrom) => {
    setProfileAddress({});
    setProfileAdd({});
    setLoaderProfile(true);
    apiCommonTrigger("post", `${Config.API_URL}/rvparks/profile`, {
      profileId: id ? parseInt(id) : null,
      latitude: id ? null : latitude,
      longitude: id ? null : longitude,
    },
    )
      .then((res) => {
        if (res.status === 200) {
          let geoDetails = res.data.geodetail;
          let profile = res.data.profile;
          let data = {}
          if (profile) {
            data = {
              latitude: geoDetails && geoDetails.latitude ? geoDetails.latitude : 0,
              longitude:
                geoDetails && geoDetails.longitude ? geoDetails.longitude : 0,
              name: profile && profile.profilename ? profile.profilename : "",
              address:
                profile && profile.streetaddress1 ? profile.streetaddress1 : "",
              address1:
                profile && profile.streetaddress2 ? profile.streetaddress2 : "",
              city: profile && profile.city ? profile.city : "",
              state: profile && profile.statecode ? profile.statecode : "",
              country: profile && profile.countyname ? profile.countyname : "",
              zip: profile && profile.zipcode ? profile.zipcode : "",
              profileId: id ? parseInt(id) : null,
            };
            const fullAddress = `${(res?.data?.profile?.streetaddress1 ? res.data.profile.streetaddress1 + ", " : profileAddress?.profileAddress || "")}
            ${res?.data?.profile?.streetaddress2 ? res.data.profile.streetaddress2 + ", " : ""}
            ${res?.data?.profile?.city ? res.data.profile.city + ", " : ""}
            ${res?.data?.profile?.statecode ? res.data.profile.statecode + " " : ""}
            ${res?.data?.profile?.zipcode || ""}`
              .replace(/,\s*,/g, ',')    // Remove consecutive commas (if empty fields in between)
              .replace(/^\s*,/, '')       // Remove leading comma
              .replace(/,\s*$/, '')       // Remove trailing comma
              .replace(/\s{2,}/g, ' ');   // Remove extra spaces between words

            setSelectedMarketAddress(profile.profilename || fullAddress);
          }
          clearSearchResult();
          if (profile !== null && profile !== undefined) {
            setProfileInfo({ ...profileInfo, profileInfo: res.data });
            setLoaderProfile(false);
            setSelectedPin(data, "db");
            if (type === "demo-market") {
              handleDemoMarketCenter(latitude, longitude)
            }
          } else {
            setProfileInfo({});
            setLoaderProfile(false);
            console.log("No profile data found, calling geocoding");
            callGeocoding(latitude, longitude, type, isFrom);
          }
          // isfavoriteCurrentAddress(data);
        } else {
          setLoaderProfile(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoaderProfile(false);
        handlingCatchError(err, navigate);
      });
  };
  // const getProfileInfo = async (id, latitude, longitude, type, isFrom) => {
  //   setProfileAddress({});
  //   setProfileAdd({});
  //   setLoaderProfile(true);
  
  //   try {
  //     const res = await apiCommonTrigger(
  //       "post",
  //       `${Config.API_URL}/rvparks/profile`,
  //       {
  //         profileId: id ? parseInt(id) : null,
  //         latitude: id ? null : latitude,
  //         longitude: id ? null : longitude,
  //       }
  //     );
  
  //     if (res.status === 200) {
  //       let geoDetails = res.data.geodetail;
  //       let profile = res.data.profile;
  //       let data = {};
  
  //       // ------------------------------
  //       // ✔ PROFILE EXISTS
  //       // ------------------------------
  //       if (profile) {
  //         data = {
  //           latitude: geoDetails?.latitude || 0,
  //           longitude: geoDetails?.longitude || 0,
  //           name: profile?.profilename || "",
  //           address: profile?.streetaddress1 || "",
  //           address1: profile?.streetaddress2 || "",
  //           city: profile?.city || "",
  //           state: profile?.statecode || "",
  //           country: profile?.countyname || "",
  //           zip: profile?.zipcode || "",
  //           profileId: id ? parseInt(id) : null,
  //         };
  
  //         const fullAddress = `${profile.streetaddress1 ? profile.streetaddress1 + ", " : ""}
  //               ${profile.streetaddress2 ? profile.streetaddress2 + ", " : ""}
  //               ${profile.city ? profile.city + ", " : ""}
  //               ${profile.statecode ? profile.statecode + " " : ""}
  //               ${profile.zipcode || ""}`
  //           .replace(/,\s*,/g, ",")
  //           .replace(/^\s*,/, "")
  //           .replace(/,\s*$/, "")
  //           .replace(/\s{2,}/g, " ");
  
  //         setSelectedMarketAddress(profile.profilename || fullAddress);
  
  //         clearSearchResult();
  //         setProfileInfo({ ...profileInfo, profileInfo: res.data });
  //         setLoaderProfile(false);
  //         setSelectedPin(data, "db");
  
  //         if (type === "demo-market") {
  //           handleDemoMarketCenter(latitude, longitude);
  //         }
  
  //         return true; // 👉 RETURN TRUE WHEN PROFILE EXISTS
  //       }
  
  //       // ------------------------------
  //       // ❌ PROFILE DOES NOT EXIST → CALL GEOCODING
  //       // ------------------------------
  //       setProfileInfo({});
  //       setLoaderProfile(false);
  
  //       const resultData = await callGeocoding(latitude, longitude, type, isFrom);
  
  //       return resultData; // 👉 RETURN TRUE/FALSE FROM GEOCODING
  //     } 
  //     else {
  //       setLoaderProfile(false);
  //       handlingCatchError(res, navigate);
  //       return true;
  //     }
  //   } catch (err) {
  //     setLoaderProfile(false);
  //     handlingCatchError(err, navigate);
  //     return true;
  //   }
  // };
  //handle change for toggle parks
  const handleChange = (event) => {
    setToggle({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  //snack bar open/close
  const snackHandleclose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ ...snack, snackOpen: false, snackMsg: "" });
  };

  const togglePopup = (param, id, name) => {
    if (id === undefined) return setOpenPopup(true);
    // when user clicks cancel btn 0 will pass from child
    if (id === "0") return setOpenPopup(param);
    if (id === "1") {
      saveMySearch(name);
      setOpenPopup(param);
    }
  };

  const saveMySearch = (name) => {
    const radioId = filterOptions.filterOptionsData.showby;
    const ops = filterOptions.filterOptionsData.filterBy.filter(item => item.typeid === 1 && item.isactive).map(item => item.id);
    const koa = filterOptions.filterOptionsData.filterBy.filter(item => item.typeid === 2 && item.isactive).map(item => item.id);
    const glamping = filterOptions.filterOptionsData.filterBy.filter(item => item.typeid === 3 && item.isactive).map(item => item.id);
    const IncludeAny = parseInt(includeAny) === 1 ? true : null;
    let inputData = {
      id: searchId,
      searchName: name,
      keyword: selectedSearch.keyword,
      street: selectedSearch.street,
      city: selectedSearch.city,
      stateId: selectedSearch.stateid,
      lat: selectedSearch.lat,
      long: selectedSearch.longi,
      radius: selectedSearch.radius,
      Hookups: selectedSearch.hookups,
      ShowersAndBathrooms: selectedSearch.showersandbathrooms,
      DumpStation: selectedSearch.dumpstation,
      OnSitePropane: selectedSearch.onsitepropane,
      TentCamping: selectedSearch.tentcamping,
      SiteLockers: selectedSearch.sitelockers,
      InternetConnectivity: selectedSearch.internetconnectivity,
      InternetConnectivityPayment: selectedSearch.internetconnectivitypayment,
      Cellphoneconnectivity: selectedSearch.cellphoneconnectivity,
      Cafe: selectedSearch.cafe,
      Cabins: selectedSearch.cabins,
      GameRoomArcade: selectedSearch.gameroomarcade,
      RecHall: selectedSearch.rechall,
      SportsCourts: selectedSearch.sportscourts,
      Petallowed: selectedSearch.petallowed,
      Fishing: selectedSearch.fishing,
      GolfCartRentals: selectedSearch.golfcartrentals,
      Swimmingpool: selectedSearch.swimmingpool,
      Lakeside: selectedSearch.lakeside,
      BeachAccess: selectedSearch.beachaccess,
      AttractionsDescriptions: selectedSearch.attractionsdescriptions,
      hasOwner: selectedSearch.hasowner,
      hasManagement: selectedSearch.hasmanagement,
      picnictable: selectedSearch.picnictable,
      FireRing: selectedSearch.firering,
      VehicularAccess: selectedSearch.vehicularaccess,
      WaterHookup: selectedSearch.waterhookup,
      SewerHookup: selectedSearch.sewerhookup,
      AdditionalLodging: selectedSearch.additionallodging,
      EATwentyAmp: selectedSearch.eatwentyamp,
      EBThirtyAmp: selectedSearch.ebthirtyamp,
      ECFiftyAmp: selectedSearch.ecfiftyamp,
      BackIn: selectedSearch.backin,
      LaundryAccess: selectedSearch.laundryAccess,
      SelfServiceCarWash: selectedSearch.selfservicecarwash,
      PullInPullThrough: selectedSearch.pullinpullthrough,
      glamping: selectedSearch.glamping,
      electriclevehiclecharging: selectedSearch.electriclevehiclecharging,
      DogParks: selectedSearch.dogparks,
      laundryaccess: selectedSearch.laundryaccess,
      Activities: selectedActivities.length > 0 ? selectedActivities.toString() : null,
      koafilters: koa.join(","),
      sizefilters: ops.join(","),
      radioid: parseInt(radioId),
      glampingfilters: glamping.join(","),
      "includeany": IncludeAny,
      minspots: (!spotsInMarket.min && spotsInMarket.max) ? 1 : (spotsInMarket.min || 1),
      maxspots: spotsInMarket.max === false ? null : spotsInMarket.max
    }
    apiCommonTrigger("post", `${Config.API_URL}/search/save`, inputData)

      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          // if (res.data === 'success') {
          setSnackOpen({
            ...snack,
            snackOpen: true,
            snackMsg: "Your search saved successfully!",
          });
          resetMapChanges();
          //  }
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };

  //drag markers positions
  const onMarkerDragEnd = useCallback((event) => {
    setSelectedPins(pre => ({
      ...pre,
      latitude: event.lngLat[1],
      longitude: event.lngLat[0],
    }));
    getProfileInfo(null, event.lngLat[1], event.lngLat[0]);
  }, []);

  const editCurrentProfileFavorite = (id) => {
    apiCommonTrigger("get", Config.API_URL + "/maps/address/favorite/", [id])
      .then((res) => {
        if (res.status === 200) {
          let obj = res.data;
          favProfileId = obj.profileid;

          if (obj.profileid !== null) {
            setProfile({
              ...profile,
              showProfile: true,
            });
            getProfileInfo(favProfileId, obj.latitude, obj.longitude);
          } else {
            setPopupInfo(true);
            callGeocoding(obj.latitude, obj.longitude);
          }

          // Clear the state after
          navigate(location.pathname, { replace: true });
          favToEdit = null;
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };

  const handleAddressFavoriteDelete = () => {
    apiCommonTrigger("delete", Config.API_URL + "/maps/address/favorite/", [isFavoriteAddr])
      .then((res) => {
        if (res.status === 200) {
          setFavoriteAddr(null);
          return;
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };
  let apLength = appliedFilter && appliedFilter.length;
  let acLength = selectedActivities && selectedActivities.length;
  const showLength = apLength + acLength;
  const [openAppliedFilter, setOpenAppliedFilter] = React.useState(false);
  const [includeAny, setIncludeAny] = React.useState(0);
  const handleClickOpen = () => {
    setOpenAppliedFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenAppliedFilter(false);
  };

  const handleChangeOperator = (event) => {
    setIncludeAny(event.target.value);
  };




  // Update filteredParksData whenever loadfacilityData.current changes
  // useEffect(() => {
  //   if(!showStorePins && activitesList){
  //      loadfacilityData.current = [];
  //   } else
  //      if ((loadfacilityData.current && loadfacilityData.current.length) || loaddevelopmentData.current) {
  //     let facilityData = loadfacilityData.current || [];
  //     let developmentData = loaddevelopmentData.current || [];
  //     const devIds = new Set(developmentData.map(item => item.typeid));
  //     const filteredFacilityData = facilityData.filter(item => !devIds.has(item.typeid));
  //     const combinedData = [...filteredFacilityData, ...developmentData];
  //     const updatedFilteredParksData = combinedData
  //       .filter(data => data.isdisplay)
  //       .sort((a, b) => b.features.length - a.features.length);
  //     if(showStorePins){
  //       loadfacilityData.current = updatedFilteredParksData; 
  //     }
  //   } 
  //    else {
  //     loadfacilityData.current = []; 
  //   }
  // }, [renderFlag]);  
  useEffect(() => {
    if (!showStorePins && activitesList) {
      setFilteredParksData([]);
    }
    else if ((loadfacilityData.current && loadfacilityData.current.length) || loaddevelopmentData.current) {
      let facilityData = loadfacilityData.current || [];
      let developmentData = loaddevelopmentData.current || [];
      const devIds = new Set(developmentData.map(item => item.typeid));
      const filteredFacilityData = facilityData.filter(item => !devIds.has(item.typeid));
      const combinedData = [...filteredFacilityData, ...developmentData];
      const updatedFilteredParksData = combinedData
        .filter(data => data.isdisplay)
        .sort((a, b) => b.features.length - a.features.length);
      if (showStorePins) {
        loadfacilityData.current = updatedFilteredParksData;
        setFilteredParksData([]);
        setTimeout(() => {
          setFilteredParksData(updatedFilteredParksData);
        }, 0);
      }
    }
    else {
      setFilteredParksData([]);
    }
  }, [renderFlag]);

  useEffect(() => {
    if (isDemoMarket && isFreeUser && filterOptions?.filterOptionsData) {
      fetchDemoMarketSummary();
    }
  }, [isDemoMarket, filterOptions]);

  //disable the search input filter in sample market
  useEffect(() => {
    if (mapRef?.current && isDemoMarket) {
      const inputElement = document.querySelector('.mapboxgl-ctrl-geocoder--input');
      if (inputElement) {
        inputElement.disabled = true; // Disable the input field
        // Prevent focus on the input
        inputElement.addEventListener('focus', (e) => e.preventDefault(), { once: true });
        // Prevent typing (on keydown event)
        inputElement.addEventListener('keydown', (e) => e.preventDefault());
      }
    }
  }, [isDemoMarket, mapRef.current]);






  const defaultPinsApiCall = (isShow) => {
    if (filterOptions && activitesList) {
      let selectedIds = filterbyOptions
        ?.filter((ele) => ele?.isactive)
        ?.map((ele) => ele?.id);
      const isFilterEmpty = !appliedFilter || appliedFilter.length === 0;
      const isActivitiesEmpty =
        !selectedActivities || selectedActivities.length === 0;
      if (isShow) {
        getParksData("default");
      } else {
        loadfacilityData.current = [];
        setFilteredParksData([]);
      }
    }
  }



  useEffect(() => {
    const isFilterEmpty = !appliedFilter || appliedFilter.length === 0;
    const isActivitiesEmpty =
      !selectedActivities || selectedActivities.length === 0;
    if (isActivitiesEmpty && isFilterEmpty && isStoresInMarketSameAsInitial()) {
      handleShowingStorePins("zoom");
    }
  }, [viewport?.zoom, activeTileSet]);

  const handleShowingStorePins = () => {
    let selectedIds = filterbyOptions
      ?.filter((ele) => ele?.isactive)
      ?.map((ele) => ele?.id);
    const zoomLevel = viewport?.zoom;
    const defaultZoomLevel =
      ConstantData.advancedMapOverlaysIds.showingPinsZoomLevel;
    if (isMarketCenterAvailable || !activeTileSet?.id) {
    } else if (activeTileSet?.id === ConstantData.advancedMapOverlaysIds.none) {
      if (!showStorePins) {
        handleSearchPins("directCall")
      }
    } else if (activeTileSet?.id) {
      let prevActiveTileSet = prevActiveTileSetRef.current;
      if (zoomLevel < defaultZoomLevel && activeTileSet?.id !== ConstantData.advancedMapOverlaysIds.traffic && (!prevActiveTileSet || prevActiveTileSet?.id === ConstantData.advancedMapOverlaysIds.none)) {
        if (arraysHaveSameElements(selectedIds, initialFilterIds)) {
          handleSearchPins("updatePin", false)

        }
      } else if (zoomLevel >= defaultZoomLevel) {
        if (!showStorePins && activitesList) {
          handleSearchPins("updatePin", true)

        }
      }
    }
  };
  useEffect(() => {
    dispatch({ type: "RESET_MAP_OVERLAYS_STATE" })
    dispatch({ type: "isTrafficReset", value: false })
    return () => {
      dispatch({ type: "RESET_MAP_OVERLAYS_STATE" });
      dispatch({ type: "isTrafficReset", value: false })
    }
  }, [location.pathname])

  const handleSearchPins = (type = "fromSearch", isShow) => {
    if (type === "directCall" || type === "fromSearch") {
      if (!showStorePins) {
        let updatedCode =
          filterbyOptions?.map((item) =>
            [1, 2, 3, 4, 5].includes(item.id)
              ? { ...item, isactive: true }
              : item
          ) || [];
        dispatch({ type: "filterbyOptions", value: updatedCode });
        dispatch({ type: "showStorePins", value: true });
        if (type === "directCall") {
          getParksData("default")
        }
      }
    } else if (type === "updatePin") {
      dispatch({ type: "showStorePins", value: isShow });
      let updatedCode =
        filterbyOptions?.map((item) =>
          [1, 2, 3, 4, 5].includes(item.id)
            ? { ...item, isactive: isShow }
            : item
        ) || [];

      dispatch({ type: "filterbyOptions", value: updatedCode });
      defaultPinsApiCall(isShow)
    }
  }

  useEffect(() => {
    if (isDemoMarket && isFreeUser && filterOptions?.filterOptionsData) {
      fetchDemoMarketSummary();
    }
  }, [isDemoMarket, filterOptions]);

  //disable the search input filter in sample market
  useEffect(() => {
    if (mapRef?.current && isDemoMarket) {
      const inputElement = document.querySelector('.mapboxgl-ctrl-geocoder--input');
      if (inputElement) {
        inputElement.disabled = true; // Disable the input field
        // Prevent focus on the input
        inputElement.addEventListener('focus', (e) => e.preventDefault(), { once: true });
        // Prevent typing (on keydown event)
        inputElement.addEventListener('keydown', (e) => e.preventDefault());
      }
    }
  }, [isDemoMarket, mapRef.current]);


  const fetchDemoMarketSummary = () => {
    setLoading(true);
    const radioId = filterOptions.filterOptionsData.showby;
    apiCommonTrigger("post", `${Config.API_URL}/markets/market/demomarketsummary`, {
      "radioid": parseInt(radioId),
    })
      .then((res) => {
        const response = res?.data;
        handleResult(
          [
            response?.marketaddress?.latitude,
            response?.marketaddress?.longitude,
          ],
          "demo-market"
        );
        receiveProps({ data: response, criteria: [] });
      })
      .catch((err) => {
        handlingCatchError(err);
        console.log(err, "error fetching demo market summary");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // update market center with some delay
  const handleDemoMarketCenter = (latitude, longitude) => {
    const timeout = setTimeout(() => {
      callMarketCenter(latitude, longitude, true);
      clearTimeout(timeout)
    }, 300)
  }

  // const filteredParksData = loadfacilityData.current;
  const handleCloseSubscriptionDialog = () => setOpenSubscriptionDialog(false);
  const handleCloseBookDemoDialog = () => setShowBookDemo(false);
  const isImpersonated = (localStorage.getItem("impersonated") === 'true')

  useEffect(() => {

    const map = mapRef.current?.getMap();
    if (!map || !activeTileSet) return;

    setTimeout(() => {
      const allLayers = map.getStyle().layers;
      const referenceLayer = allLayers.find(
        l =>
          l.type === "symbol" &&
          l.id.includes("label")
      );

      const beforeId = referenceLayer?.id;
      const orderedLayers = [
        "tile-fill-layer",
        "tile-border-layer",
        "tile-line-layer",
      ];

      orderedLayers.forEach((layerId) => {
        if (map.getLayer(layerId) && beforeId) {
          try {
            map.moveLayer(layerId, beforeId);
          } catch (err) {
            console.warn(`Failed to move ${layerId}`, err);
          }
        }
      });
    }, 100);
  }, [activeTileSet]);

  useEffect(() => {
    showPinsRef.current = showStorePins;
  }, [showStorePins])

  useEffect(() => {
    prevActiveTileSetRef.current = activeTileSet;
  }, [activeTileSet]);

  const legendItems = activeTileSet?.layertype === "line"
    ? activeTileSet.colorCodes.filter((ele, i) => trafficCountsIndex.includes(i))
    : activeTileSet?.colorCodes;

  useEffect(() => {
    const inputElement = document.querySelector(
      ".mapboxgl-ctrl-geocoder--input"
    );
    if (inputElement) {
      setAnchorEl(inputElement);
    }
  }, []);


  // Callback function to check for class existence
  const hasClass = (className) => {
    return !!containerRef.current?.querySelector(`.${className}`);
  };

  return (
    <div id="main" className={`market-search-main ${hasClass("checkIsFilerApplied") ? "applied_filters" : ""}`} ref={containerRef}>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      ) : null}

      <div className="mapbox-maps">
        <div className={isImpersonated ? "search-map admin-view-map" : "search-map"}>
          {!isDemoMarket ? null : (
            <div className="blur-container">
              <div className="blur-sample-market w-100 h-100 bg-transparent" />
            </div>
          )}
          <div ref={geocoderContainerRef} className="search-box" />
          <div style={{ display: "none" }}>
            <MyMarketLayout ref={marketRef} />
          </div>
          
          <Filter
            ref={childRef}
            radius={radius}
            passValue={receiveProps}
            latitude={
              showCircle && circles !== null ? selectedPins.latitude : null
            }
            longitude={
              showCircle && circles !== null ? selectedPins.longitude : null
            }
            showCircle={showCircle}
            editFilter={
              appliedFilter && appliedFilter.length !== 0 ? appliedFilter : []
            }
            updatedFilterObj={appliedFilterObj}
            handleSearchPins={handleSearchPins}
            disableFilter={isFreeUser || isDemoMarket}
            setFilteredParksData={setFilteredParksData}
            setRenderFlag={setRenderFlag}

          />
          <div className="reset-btn-map">
            <Button
              disabled={isDemoMarket ? true : searchPinAppending}
              id="map-reset-search-explorer"
              className="reset-btn"
              onClick={() => {
                resetMapChanges(true)
              }}
            >
              Reset
            </Button>
            {(appliedFilter && appliedFilter.length > 0) || (selectedActivities && selectedActivities.length > 0) || !isStoresInMarketSameAsInitial() ?
              <Button disabled={isDemoMarket ? true : searchPinAppending} style={{ visibility: isEnabled ? 'hidden' : "" }} onClick={togglePopup} className="reset-btn save-search" variant="outlined"  ><BookmarkBorderOutlinedIcon /> Save Search </Button>
              : ""}
          </div>
        </div>
        {openPopup ? (
          <ConfirmationPopup
            open={openPopup}
            togglePopup={togglePopup}
            title={1}
            searchName={searchName}
          />
        ) : (
          ""
        )}

        <div className="map-box-section">
          {(appliedFilter && appliedFilter.length > 0) ||
            (selectedActivities && selectedActivities.length > 0) || !isStoresInMarketSameAsInitial() ? (
            <div className="appliedFilter checkIsFilerApplied">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                <span className="filters-label">Applied Filters:</span>
                {appliedFilter && appliedFilter.length <= 13 ? (
                  <>
                    {appliedFilter &&
                      appliedFilter.map((data) => {
                        let value =
                          data.name.toLowerCase() !== "radius"
                            ? data.value
                            : "";
                        if (data.name.toLowerCase() !== "radius") {
                          if (
                            data.name.toLowerCase() !== "radius" &&
                            data.name.toLowerCase() === "stateId".toLowerCase()
                          ) {
                            value = stateList
                              .filter((obj) => obj.value === data.value)
                              .map((x) => x.label);
                          }
                          if (
                            data.name.toLowerCase() !== "radius" &&
                            data.name.toLowerCase() ===
                            "internetConnectivity".toLowerCase()
                          ) {
                            if (data.value === "1") {
                              value = "Cable";
                            } else if (data.value === "2") {
                              value = "Not Available";
                            } else if (data.value === "0") {
                              value = null;
                            } else {
                              value = "Wifi";
                            }
                          }
                          if (
                            data.name.toLowerCase() !== "radius" &&
                            data.name.toLowerCase() ===
                            "internetConnectivityPayment".toLowerCase()
                          ) {
                            if (data.value === "1") {
                              value = "Free";
                            } else if (data.value === "2") {
                              value = "Not Available";
                            } else if (data.value === "0") {
                              value = null;
                            } else {
                              value = "Paid";
                            }
                          }
                          if (
                            data.name.toLowerCase() !== "radius" &&
                            data.name.toLowerCase() !==
                            "InternetConnectivity".toLowerCase() &&
                            data.name.toLowerCase() !==
                            "InternetConnectivityPayment".toLowerCase() &&
                            data.name.toLowerCase() !== "stateId".toLowerCase()
                          ) {
                            if (data.value === "1") {
                              value = "No";
                            } else if (data.value === "3") {
                              value = "Yes";
                            } else if (data.value === "0") {
                              value = null;
                            }
                          }

                          if (
                            data.name.toLowerCase() === "hasOwner".toLowerCase()
                          ) {
                            value = "Yes";
                          }
                          if (
                            data.name.toLowerCase() ===
                            "hasManagement".toLowerCase()
                          ) {
                            value = "Yes";
                          }
                        }

                        // let value =
                        //   data.label === "RV Park's State"
                        //     ? stateList
                        //         .filter((obj) => obj.value === data.value)
                        //         .map((x) => x.label)
                        //     : data.value;

                        return value === "" ||
                          value === null ||
                          value.length === 0 ? (
                          ""
                        ) : (
                          <Chip
                            label={
                              `${data.name.toLowerCase() ===
                                "eatwentyamp".toLowerCase()
                                ? "20 Amp"
                                : data.name.toLowerCase() ===
                                  "ecfiftyamp".toLowerCase()
                                  ? "50 Amp"
                                  : data.name.toLowerCase() ===
                                    "ebthirtyamp".toLowerCase()
                                    ? "30 Amp"
                                    : data.label
                              }` +
                              `: ` +
                              `${value}`
                            }
                            onDelete={handleDelete(data.name, null, data)}
                          />
                        );
                      })}
                  </>
                ) : (
                  appliedFilter &&
                  appliedFilter.slice(0, 13).map((data) => {
                    let value =
                      data.name.toLowerCase() !== "radius" ? data.value : "";
                    if (data.name.toLowerCase() !== "radius") {
                      if (
                        data.name.toLowerCase() !== "radius" &&
                        data.name.toLowerCase() === "stateId".toLowerCase()
                      ) {
                        value = stateList
                          .filter((obj) => obj.value === data.value)
                          .map((x) => x.label);
                      }
                      if (
                        data.name.toLowerCase() !== "radius" &&
                        data.name.toLowerCase() ===
                        "internetConnectivity".toLowerCase()
                      ) {
                        if (data.value === "1") {
                          value = "Cable";
                        } else if (data.value === "2") {
                          value = "Not Available";
                        } else if (data.value === "0") {
                          value = null;
                        } else {
                          value = "Wifi";
                        }
                      }
                      if (
                        data.name.toLowerCase() ===
                        "internetConnectivityPayment".toLowerCase()
                      ) {
                        if (data.value === "1") {
                          value = "Free";
                        } else if (data.value === "2") {
                          value = "Not Available";
                        } else if (data.value === "0") {
                          value = null;
                        } else {
                          value = "Paid";
                        }
                      }
                      if (
                        data.name.toLowerCase() !==
                        "InternetConnectivity".toLowerCase() &&
                        data.name.toLowerCase() !==
                        "InternetConnectivityPayment".toLowerCase() &&
                        data.name.toLowerCase() !== "stateId".toLowerCase()
                      ) {
                        if (data.value === "1") {
                          value = "No";
                        } else if (data.value === "3") {
                          value = "Yes";
                        } else if (data.value === "0") {
                          value = null;
                        }
                      }

                      if (
                        data.name.toLowerCase() === "hasOwner".toLowerCase() ||
                        data.name.toLowerCase() ===
                        "hasManagement".toLowerCase()
                      ) {
                        if (data.value === "true") return (value = "Yes");
                      }
                    }

                    return value === "" ||
                      value === null ||
                      value.length === 0 ? (
                      ""
                    ) : (
                      <Chip
                        label={
                          `${data.name.toLowerCase() ===
                            "eatwentyamp".toLowerCase()
                            ? "20 Amp"
                            : data.name.toLowerCase() ===
                              "ecfiftyamp".toLowerCase()
                              ? "50 Amp"
                              : data.name.toLowerCase() ===
                                "ebthirtyamp".toLowerCase()
                                ? "30 Amp"
                                : data.label
                          }` +
                          `: ` +
                          `${value}`
                        }
                        onDelete={handleDelete(data.name, null, data)}
                      />
                    );
                  })
                )}

                {appliedFilterObj &&
                  appliedFilterObj.activities !== null &&
                  selectedActivities &&
                  selectedActivities.length > 0
                  ? selectedActivities && selectedActivities.length > 0
                    ? selectedActivities.map((step) => {
                      let _obj = activitesList.find((x) => x.value === step);
                      return (
                        <Chip
                          label={_obj.label ? _obj.label : "-"}
                          onDelete={handleDelete(_obj.value, "activities")}
                        />
                      );
                    })
                    : ""
                  : ""}
                {
                  Object.values(spotsInMarket)?.map((value, index) => {
                    let Label = index === 0 ? 'Min Spots' : "Max Spots"
                    if (value !== null && value !== false) {
                      return (<Chip
                        label={`${Label}:${value}`}
                        onDelete={handleDelete(index === 0 ? 'min' : "max", "spotsInMarket")}
                      />)
                    }
                  })
                }
                {showLength <= 13 ? (
                  ""
                ) : showLength !== 0 ? (
                  <div
                    onClick={() => childRef.current.openFilter(true)}
                    className="showmore-link"
                  >
                    Show More
                  </div>
                ) : (
                  ""
                )}
                <span
                  className="text-right filter-settings-icon"
                  style={{
                    float: "right",
                    cursor: "pointer",
                    marginTop: "3px",
                    fontSize: "13px",
                  }}
                  onClick={handleClickOpen}
                >
                  <TuneIcon /> Filter Settings
                </span>
              </Paper>
              <div>
                <Dialog
                  open={openAppliedFilter}
                  onClose={handleCloseFilter}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  className="modal-custom-popup filter-settings-popup"
                >
                  {isLoading ? (
                    <div className="loader-wrap">
                      <div className="loading loder-popup"></div>
                    </div>
                  ) : null}
                  <DialogTitle id="alert-dialog-title">
                    Filter Settings
                  </DialogTitle>
                  <DialogContent>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={includeAny ? includeAny : 0}
                        onChange={handleChangeOperator}
                      >
                        <FormControlLabel
                          value={parseInt(0)}
                          control={<Radio />}
                          label="Include All"
                        />
                        <FormControlLabel
                          value={parseInt(1)}
                          control={<Radio />}
                          label="Include Any"
                        />
                      </RadioGroup>
                    </FormControl>
                    <DialogContentText
                      id="alert-dialog-description"
                      className="body-cont-filters"
                    >
                      <div className="txt-container">
                        {parseInt(includeAny) === 1 ? (
                          <p className="radio-txt">
                            The "Include Any" requires atleast one condition to
                            be true. It's like having a checklist where all the
                            requirements must be met simultaneousely.
                          </p>
                        ) : (
                          <p className="radio-txt">
                            The "Include All" requires all conditions to be
                            true. It's like having multiple options, and as long
                            as one of them is true, the result will be true.
                          </p>
                        )}
                      </div>
                      <p className="filter-desc mt-3">
                        By using this logical operators, You can create powerful
                        filters that help you find excatly what you're looking
                        for or provide you with a range of suitable options
                        based on your preferences.{" "}
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseFilter} className="reset-opt">
                      Cancel
                    </Button>
                    <Button
                      onClick={handleDelete(null, "includeOperator")}
                      className="market-btn"
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          ) : (
            ""
          )}


          {/* Hazard Legend code */}
          {(activeTileSet?.TileFilter?.id || activeTileSet?.id === ConstantData.advancedMapOverlaysIds.eoz || (activeTileSet?.layertype === "line" && viewport.zoom >= ConstantData.advancedMapOverlaysIds.trafficZoomLevel && trafficCounts?.length && trafficCounts?.some(Boolean))) ? (
            <div
              className="hazards-legend"
            >

              <p style={{ fontWeight: 600, fontSize: "14px", gridColumn: '1 / -1' }}>

                {activeTileSet?.TileFilter?.id ? activeTileSet?.TileFilter?.labletext : activeTileSet.name}
                {activeTileSet?.layertype === "line" && viewport.zoom >= 10 ? "- AADT" : ""}
                {activeTileSet?.layertype === "line" ?
                  <InfoTooltip
                    interactive
                    arrow
                    onOpen={() => preventIdleRef.current = false}
                    placement='top'
                    title={<div style={{ width: '240px' }}>
                      <strong >Annual Average Daily Traffic (AADT)</strong>
                      <p style={{ marginTop: "5px" }} className="mb-0">Average number of all motor vehicles using a road each day, based on annual data from state transportation departments.</p>
                    </div>
                    }
                  >
                    <span className='summary-kd-info pl-1'>
                      <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: "18px" }} />
                    </span>
                  </InfoTooltip> : ""}
              </p>
              {legendItems?.map((currentItem, i) => {
                const isTraffic = activeTileSet?.layertype === "line";
                return (
                  <div className="hazards-div" key={i}>
                    <p
                      style={{
                        height: "10px",
                        width: "10px",
                        boxShadow: "0 0 1px 1px #c9c9c9",
                        backgroundColor: currentItem?.fillcolor,
                        borderRadius: "10px",
                        margin: "0",
                        opacity: isTraffic ? 1 : 0.8,
                      }}
                    />
                    {!isTraffic && <span className="lagend-name">{currentItem?.name}</span>}
                    {isTraffic ? <span>{trafficCounts[i]}</span> : ""}
                  </div>
                );
              })}
            </div>
          ) : ""}

          <Row className="position-relative">
            <Col md={12}>
              <div className="mapbox-full-width">
                {/* Top search popup (address or lat/lng) */}
                {isFreeUser && !hideSearchExplorerBox &&( !isEdit && !isFav) && <div className="search-explorer-bar">
                  <div className="top-heading" style={{ marginBottom: 6 }}>
                    <h3 style={{ margin: 0}}><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-compass h-5 w-5" aria-hidden="true"><path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path><circle cx="12" cy="12" r="10"></circle></svg>Search Explorer</h3>
                  </div>
                  <div className="search-boxes">
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="searchType"
                        name="searchType"
                        value={searchTypeNew}
                        onChange={(e)=>handleRadioChange(e,"new")}
                        row
                      >
                        {returnSearchTypeHtml()}
                      </RadioGroup>
                      {searchTypeNew === 2 && (
                        <>
                          <Box display="flex" flexDirection="column" className="miss-prop-devpt-popup-form p-0 mt-1 mb-2 pb-1" style={{gap: '12px'}}>
                            <TextField
                            className="textbox-custom"
                              type="text"
                              label="Latitude"
                              variant="outlined"
                              value={topLatitude}
                              onChange={(e) => { 
                                const val = e.target.value;
                                  setTopLatitude(val); 
                                  setLatErrorTop(''); 
                              }}
                              onPaste={handlePasteLat}
                              inputProps={{
                              inputMode: 'text',
                              pattern: '[0-9°\'" NSEW+\\-.]*', // allows all valid coordinate chars
                            }}
                              fullWidth
                            />
                            <TextField
                            className="textbox-custom"
                              type="text"
                              label="Longitude"
                              variant="outlined"
                              value={topLongitude}
                              onChange={(e) => { 
                                const val = e.target.value;
                                  setTopLongitude(val); 
                                  setLonErrorTop(''); 
                              }}
                              onPaste={handlePasteLon}
                              inputProps={{
                              inputMode: 'text',
                              pattern: '[0-9°\'" NSEW+\\-.]*', // allows all valid coordinate chars
                            }}
                              fullWidth
                            />
                          </Box>
                          {latErrorTop && (
                            <div style={{ 
                              textAlign: 'left',
                              color: '#d32f2f',
                              fontSize: '12px',
                              marginTop: '8px',
                              marginBottom: '8px',
                              fontFamily: 'Roboto, sans-serif'
                            }}>
                              {latErrorTop}
                            </div>
                          )}
                          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <MUIButton variant="contained" className="search-btn-bar" color="primary" onClick={handleSearchTop} style={{ textTransform: 'none' }}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search h-4 w-4" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg> Search</MUIButton>
                          </div>
                        </>
                      )}
                    </FormControl>
                    {/* Container where the popup geocoder will mount when Address search is selected */}
                    {searchTypeNew === 1 && (!isEdit &&!isFav)&&(
                      <div
                        ref={geocoderPopupContainerRef}
                        id="geocoder-popup-container"
                        // style={{ width: "100%", marginTop: 8 }}
                      />
                    )}

                  </div>
                  {/* <p className="take-peek">Take a peek, then unlock <b style={{color: '#000'}}>30-day access</b> to in-depth data and reports for that area.</p> */}
                </div>}
                <Map
                  {...viewport}
                  onClick={ismarketWizard || (isFreeUser && !isDemoMarket) ? null : getcoordinates}
                  ref={mapRef}
                  getCursor={(e) => "pointer"}
                  onViewportChange={handleViewportChange}
                  mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
                  mapStyle={"mapbox://styles/mapbox/streets-v11"}
                  dragRotate={isDemoMarket ? false : undefined}
                  dragPan={isDemoMarket ? false : undefined}
                  scrollZoom={isDemoMarket ? null : undefined}
                  doubleClickZoom={isDemoMarket ? false : true}
                >
                  <Geocoder
                    mapRef={mapRef}
                    containerRef={geocoderContainerRef}
                    onViewportChange={handleGeocoderViewportChange}
                    mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
                    onInit={debouncedExternalGeocoder}
                    onResult={isDemoMarket ? null : handleResult}
                    countries="US"
                    minLength={3}
                  />
                  {searchTypeNew === 1 && isFreeUser && !hideSearchExplorerBox && (!isEdit&& !isFav) && (
                    <Geocoder
                      mapRef={mapRef}
                      containerRef={geocoderPopupContainerRef}
                      placeholder="Enter a address to start"
                      onViewportChange={handleGeocoderViewportChange}
                      mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
                      onInit={debouncedExternalGeocoder}
                      onResult={isDemoMarket ? null : handleResult}
                      countries="US"
                      minLength={3}
                    />
                  )}               

                  {/* Show the pins data for both free and paid users - with the events restriction for free users */}
                  {filteredParksData.map((data, index) => {
                    return (
                      <Source
                          key={index}
                          id={`source-${index}`}
                          type="geojson"
                          data={data}
                        >
                          <Layer
                            id={`layer-source-${index}`}
                            type="circle"
                            source={`source-${index}`}
                            metadata={{ isPin: true }}
                            paint={{
                              "circle-radius": 4,
                              "circle-color": ["get", "colorcode"],
                            }}
                          />
                        </Source>
                    );
                  })}


                  {marketCenter.latitude &&
                    marketCenter.longitude &&
                    activeStep !== 2 ? (
                    <Marker
                      longitude={marketCenter.longitude}
                      latitude={marketCenter.latitude}
                      draggable
                      onDragEnd={onMarkerDragEnd}
                    >
                      <img
                        src={markerImg}
                        alt="Marker Pin"
                        height={20}
                        viewBox="0 0 24 24"
                        style={{
                          ...pinStyle,
                          transform: `translate(${-10 / 2}px,${-10}px)`,
                        }}
                        onClick={() => {
                          setProfile({
                            ...profile,
                            showProfile: selectedPins.profileId ? true : false,
                          });
                          setSummary({ ...summary, showSummary: false });
                          clearSearchResult();
                          if (selectedPins.profileId !== null) {
                            getProfileInfo(
                              selectedPins.profileId,
                              selectedPins.latitude,
                              selectedPins.longitude
                            );
                          } else {
                            callGeocoding(
                              selectedPins.latitude,
                              selectedPins.longitude
                            );
                          }
                        }}
                      ></img>
                    </Marker>
                  ) : (
                    ""
                  )}
                  {selectedPins.latitude &&
                    selectedPins.longitude &&
                    activeStep !== 2 ? (
                    <Marker
                      longitude={selectedPins.longitude}
                      latitude={selectedPins.latitude}
                      draggable
                      onDragEnd={onMarkerDragEnd}
                    >
                      {marketCenter.latitude === selectedPins.latitude &&
                        marketCenter.longitude === selectedPins.longitude ? (
                        ""
                      ) : (
                        <img
                          src={pointMarker}
                          alt="Marker Pin"
                          height={20}
                          viewBox="0 0 24 24"
                          style={{
                            ...pinStyle,
                            transform: `translate(${-10 / 2}px,${-10}px)`,
                          }}
                          onClick={() => {
                            setProfile({
                              ...profile,
                              showProfile: selectedPins.profileId
                                ? true
                                : false,
                            });
                            setSummary({ ...summary, showSummary: false });
                            clearSearchResult();
                            if (selectedPins.profileId !== null) {
                              getProfileInfo(
                                selectedPins.profileId,
                                selectedPins.latitude,
                                selectedPins.longitude
                              );
                            } else {  
                              callGeocoding(
                                selectedPins.latitude,
                                selectedPins.longitude
                              );
                            }
                          }}
                        ></img>
                      )}
                    </Marker>
                  ) : activeStep === 2 ? (
                    <Marker
                      latitude={
                        supplyValues.latitude !== undefined &&
                          supplyValues.latitude
                          ? supplyValues.latitude
                          : selectedPins.latitude
                      }
                      longitude={
                        supplyValues.longitude !== undefined &&
                          supplyValues.longitude
                          ? supplyValues.longitude
                          : selectedPins.longitude
                      }
                    >
                      <img
                        src={pointMarker}
                        alt="Marker Pin"
                        height={20}
                        viewBox="0 0 24 24"
                        style={{
                          ...pinStyle,
                          transform: `translate(${-10 / 2}px,${-10}px)`,
                        }}
                        onClick={() => {
                          setProfile({ ...profile, showProfile: true });
                          setSummary({ ...summary, showSummary: false });
                          getProfileInfo(
                            selectedPins.profileId,
                            selectedPins.latitude,
                            selectedPins.longitude
                          );
                        }}
                      ></img>
                    </Marker>
                  ) : (
                    ""
                  )}
                  {(circles || resetValues) && showCircle && activeStep < 2 ? (
                    <>
                      <Source id="route" type="geojson" data={circles} />
                      <Layer
                        id="route"
                        type="line"
                        source="route"
                        layout={{
                          "line-join": "round",
                          "line-cap": "round",
                        }}
                        metadata={{ isPin: true }}
                        paint={{
                          "line-color": "#000000",
                          "line-width": 2,
                        }}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  <Source id="route1" type="geojson" data={supplyCircles} />
                  <Layer
                    type="line"
                    source="route1"
                    layout={{
                      "line-join": "round",
                      "line-cap": "round",
                      visibility:
                        showSupplyCircle && activeStep > 1 ? "visible" : "none",
                    }}
                    metadata={{ isPin: true }}
                    paint={{
                      "line-color": "#000000",
                      "line-width": 2,
                    }}
                  />
                  {/* === Advanced Map Overlays === */}
                  {activeTileSet &&
                    <Source
                      id={`fema-tileset-${activeTileSet?.sourcelayer}`}
                      type="vector"
                      url={`mapbox://${activeTileSet?.tilesetid}`}
                      key={activeTileSet?.sourcelayer}
                    >
                      {activeTileSet?.layertype === "line" && viewport.zoom >= 10 &&
                        <Layer
                          id={`tile-line-layer`}
                          type="line"
                          source={`traffic-tileset-${activeTileSet.id}`}
                          source-layer={activeTileSet.sourcelayer}
                          paint={{
                            'line-color': trafficColorExp.length ? trafficColorExp : activeTileSet?.fillcolor,
                            'line-width': getTrafficLineWidth(viewport?.zoom)
                          }}
                        />}

                      {activeTileSet?.layertype === "tileset" && (() => {

                        const isEOZ = activeTileSet?.id === ConstantData.advancedMapOverlaysIds.eoz;
                        const tileFilterKey = activeTileSet?.TileFilter?.lableid;
                        const propertyName = isEOZ ? 'TRACTTYPE' : `${tileFilterKey}_RISKR`;

                        const hasFilter = isEOZ ? true : Boolean(activeTileSet?.TileFilter && tileFilterKey);

                        const fillPaint = hasFilter
                          ? {
                            'fill-color': generateMapboxColorExpression(propertyName, activeTileSet.colorCodes, 'fillcolor', '#fff'),
                            'fill-opacity': 0.8,
                            'fill-outline-color': generateMapboxColorExpression(propertyName, activeTileSet.colorCodes, 'bordercolor', '#999999'),
                          }
                          : {
                            'fill-color': activeTileSet?.fillcolor || '#ffffff',
                            'fill-outline-color': activeTileSet?.bordercolor || '#999999',
                            'fill-opacity': 0.8,
                          };

                        const borderPaint = hasFilter
                          ? {
                            'line-color': generateMapboxColorExpression(propertyName, activeTileSet.colorCodes, 'bordercolor', '#999999'),
                            'line-width': 0.5,
                            'line-opacity': 0.8,
                          }
                          : {
                            'line-color': activeTileSet?.bordercolor || '#999999',
                            'line-width': 1,
                            'line-opacity': 0.8,
                          };

                        const layerFilter = hasFilter
                          ? ['all', ['!=', ['get', propertyName], null]]
                          : true;

                        return (
                          <>
                            <Layer
                              id="tile-fill-layer"
                              type="fill"
                              source={`fema-tileset-${activeTileSet?.sourcelayer}`}
                              source-layer={activeTileSet?.sourcelayer}
                              paint={fillPaint}
                              filter={layerFilter}
                            />
                            <Layer
                              id="tile-border-layer"
                              type="line"
                              source={`fema-tileset-${activeTileSet?.sourcelayer}`}
                              source-layer={activeTileSet?.sourcelayer}
                              paint={borderPaint}
                              filter={layerFilter}
                            />
                          </>
                        );
                      })()}
                    </Source>}

                  <div className="zoom-plus-minus">
                    <NavigationControl showCompass={false} />
                  </div>
                  {isDemoMarket ? null : (
                    <div className="zoom-plus-minus">
                      <NavigationControl showCompass={false} />
                    </div>
                  )}
                  {popupInfo &&
                    selectedPins.latitude &&
                    selectedPins.longitude && (
                      <Popup
                        anchor="top"
                        longitude={selectedPins.longitude}
                        latitude={selectedPins.latitude}
                        onClose={() => setPopupInfo(false)}
                        className="info-market-popup"
                      >
                        {isFreeUser || isDemoMarket ? (
                          ""
                        ) : (
                          <button
                            aria-label="upload picture"
                            component="span"
                            className="star-custom-btn"
                          >
                            {isFavoriteAddr ? (
                              <div
                                className="star-icon selected"
                                onClick={() => {
                                  handleAddressFavoriteDelete();
                                }}
                              />
                            ) : (
                              <div
                                className="star-icon"
                                onClick={() => {
                                  favoriteCurrentAddress();
                                }}
                              />
                            )}
                          </button>
                        )}
                        <div
                          className={
                            isFreeUser
                              ? "free-user-map use-address"
                              : "use-address"
                          }
                        >
                          <div>
                            {isFreeUser && !isDemoMarket ? (
                              <p className="address-section">
                                There is a facility here
                              </p>
                            ) : (
                              <p className="address-section">
                                <FmdGoodOutlinedIcon />
                                {profileInfo &&
                                  profileInfo.profileInfo !== undefined &&
                                  profileInfo.profileInfo.profile &&
                                  profileInfo.profileInfo.profile.streetaddress1
                                  ? profileInfo.profileInfo.profile
                                    .streetaddress1 + ", "
                                  : profileAddress &&
                                    profileAddress.profileAddress
                                    ? profileAddress.profileAddress
                                    : ""}
                                {profileInfo &&
                                  profileInfo.profileInfo !== undefined &&
                                  profileInfo.profileInfo.profile &&
                                  profileInfo.profileInfo.profile.streetaddress2
                                  ? profileInfo.profileInfo.profile
                                    .streetaddress2 + ", "
                                  : ""}
                                {profileInfo &&
                                  profileInfo.profileInfo !== undefined &&
                                  profileInfo.profileInfo.profile &&
                                  profileInfo.profileInfo.profile.city
                                  ? profileInfo.profileInfo.profile.city + ", "
                                  : ""}
                                {profileInfo &&
                                  profileInfo.profileInfo !== undefined &&
                                  profileInfo.profileInfo.profile &&
                                  profileInfo.profileInfo.profile.statecode
                                  ? profileInfo.profileInfo.profile.statecode +
                                  " "
                                  : ""}
                                {profileInfo &&
                                  profileInfo.profileInfo !== undefined &&
                                  profileInfo.profileInfo.profile &&
                                  profileInfo.profileInfo.profile.zipcode
                                  ? profileInfo.profileInfo.profile.zipcode
                                  : ""}
                              </p>
                            )}
                            {isFreeUser && !isDemoMarket ? (
                              <button
                                onClick={() => setOpenSubscriptionDialog(true)}
                                className="upgrade-mrk-btn"
                              >
                                Upgrade to view more details
                              </button>
                            ) : (
                              ""
                            )}
                            {isDemoMarket ? null : (
                              <button
                                className="use-market"
                                onClick={() =>
                                  callMarketCenter(
                                    selectedPins.latitude,
                                    selectedPins.longitude,
                                    true
                                  )
                                }
                              >
                                Use as market center
                              </button>
                            )}
                          </div>
                        </div>
                      </Popup>
                    )}

                  {assertPinData && assertLatLong?.lng &&
                    <Popup
                      anchor="top"
                      longitude={assertLatLong.lng}
                      latitude={assertLatLong.lat}
                      onClose={() => {
                        setAssertLatLong({ lat: null, lng: null });
                      }}
                      className="info-market-popup"
                    >
                      {renderAsserDataBasedOnTypeId(assertPopType, assertPinData)}
                    </Popup>
                  }


                </Map>
              </div>
            </Col>
            {searchCount &&
              rvParksData.rvParksData &&
              rvParksData.rvParksData.features.length > 0 ? (
              <Col className="market-distance p-0 rvparks-founded">
                <div className="rvparks-count">
                  <FmdGoodOutlinedIcon />
                  {rvParksData.rvParksData.features.length} RV Parks found
                </div>
              </Col>
            ) : (
              ""
            )}
            {selectedPins.latitude &&
              selectedPins.longitude &&
              showCircle &&
              activeStep !== 4 &&
              activeStep !== 1 ? (
              activeStep === 0 && ismarketWizard ? (
                ""
              ) : (
                <Col className="market-distance p-0">
                  <h5>{"Market Distance"}</h5>
                  <div
                    className={`slider-radius ${isDemoMarket ? "blur-sample-market" : ""
                      }`}
                  >
                    <label className="radius-value">{radius} Miles</label>
                    <label
                      className="label-values"
                      style={{ marginRight: "3px" }}
                    >
                      10
                    </label>
                    <input
                      name={"radius"}
                      type="range"
                      min={10}
                      max={ConstantData.radiusMaxCount}
                      value={radius}
                      disabled={
                        selectedPins.latitude !== null &&
                          selectedPins.longitude !== null &&
                          !isDemoMarket
                          ? false
                          : true
                      }
                      onChange={(e) => {
                        if (!isDemoMarket) {
                          handleOnChangeRadius(e, "1")
                        }
                      }}
                      step={1}
                    />{" "}
                    <label className="label-values">
                      {ConstantData.radiusMaxCount}
                    </label>
                  </div>
                </Col>
              )
            ) : (
              ""
            )}
            {summary.showSummary ? (
              <Col md="2" className="market-summary-popup p-0">
                <MarketSummary
                  toggleBtnClose={toggleBtnClose}
                  toggleSummary={toggleSummary}
                  summaryData={summaryInfo}
                  demoSummaryData={demo_summaryInfo}
                  profileData={profileInfo}
                  address={profileAdd}
                  showAddress={profile.showProfile}
                  setOpenSubscriptionDialog={setOpenSubscriptionDialog}
                  loader={isSummaryLoading}
                  sliderValue={radius}
                  {...summary}
                  {...profileAddress}
                  {...profileAdd}
                  {...profile}
                />
                {openMarket ? (
                  <div className="button-margin">
                    {viewport.latitude !== null &&
                      viewport.longitude !== null &&
                      !isSummaryLoading ? (
                      <Button
                        className="add-market"
                        id="add-btn"
                        onClick={() => {
                          if (isDemoMarket) {
                            // resetMapChanges("default", "/market-search");
                            navigate("/market-search");
                            return;
                          }
                          setMarketWizard(true);
                          setPopupInfo(false);
                        }}
                      >
                        {isDemoMarket ? null : <AddCircleOutlineIcon />}{" "}
                        {isDemoMarket ? "Exit Sample Market" : "Add Market"}
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </Col>
            ) : null}

            {ismarketWizard && activeStep > 1 && activeStep < 4 ? (
              <Col className="market-center-popup p-0">
                <div className="market-summary-title">
                  <h5>Market Center </h5>
                </div>
                <p className="address-section">
                  {/* <FmdGoodOutlinedIcon /> */}
                  <span>
                    {" "}
                    {radius
                      ? `${activeStep === 2
                        ? supplyRadius
                        : activeStep === 3
                          ? demandRadius
                          : radius
                      } miles radius around `
                      : ""}
                  </span>
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.streetaddress1
                    ? profileInfo.profileInfo.profile.streetaddress1
                    : profileAddress && profileAddress.profileAddress
                      ? profileAddress.profileAddress
                      : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.streetaddress2
                    ? ", " + profileInfo.profileInfo.profile.streetaddress2
                    : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.city
                    ? ", " + profileInfo.profileInfo.profile.city + ", "
                    : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.statecode
                    ? profileInfo.profileInfo.profile.statecode + " "
                    : ""}
                  {profileInfo &&
                    profileInfo.profileInfo !== undefined &&
                    profileInfo.profileInfo.profile &&
                    profileInfo.profileInfo.profile.zipcode
                    ? profileInfo.profileInfo.profile.zipcode
                    : ""}
                </p>
              </Col>
            ) : (
              ""
            )}
            {profile.showProfile ? (
              <Col className="market-tabs-popup p-0">
                <MarketProfile
                  isFav={isFavoriteAddr}
                  profileData={profileInfo}
                  toggleProfile={toggleProfile}
                  callMarketCenter={callMarketCenter}
                  profileId={favProfileId}
                  loaderProfile={loaderProfile}
                  id={favId}
                  isDemoMarket={isDemoMarket}
                  onExitDemoMarket={() =>
                    resetMapChanges(true, "default", "/market-search")
                  }
                  {...profile}
                />
              </Col>
            ) : null}
            
            {ismarketWizard ? (
            <AddMarket
              showAddMarket={showAddMarket}
              getMarketInfo={getMarketInfo}
              setActiveStep={setActiveSteps}
              profileData={profileInfo}
              address={profileAddress.profileAddress}
              marketName={
                marketInfo && marketInfo.marketName
                  ? marketInfo.marketName
                  : selectedMarketAddress
              }
              supplyRadius={supplyRadius}
              demandRadius={demandRadius}
              centerRadius={radius}
              latitude={selectedPins.latitude}
              longitude={selectedPins.longitude}
              summaryData={summaryInfo}
              rvcount={summaryInfo.rvcount}
              isEdit={isEdit}
              marketId={marketId}
              packDetails={props.packDetails}
            />
            ) : null}
          </Row>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snack.snackOpen}
          id="snack-success"
          className="snack-bar"
          maxsnack={3}
          autoHideDuration={5000}
          onClose={snackHandleclose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{snack.snackMsg}</span>}
          action={[
            <Clear
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={snackHandleclose}
            />,
          ]}
        />
      </div>
      {/* property btn */}
      {isDemoMarket ? null : <MarketProperty fromPage={"map-search"} />}
      {/* subscription upgrade dialog */}
      <SubscriptionDialog
        isOpen={openSubscriptionDialog}
        onClose={handleCloseSubscriptionDialog}
        packageDetail={props?.packDetails}
      />
      
    </div>
  );
});
export default SearchExplorer;
